// vim:et sts=2 sw=2

const $ = require('jquery');
const _ = require('lodash');
const d3 = require('d3');
const L = require('leaflet');
const composer = require('./composer-risk');
require('./vendor/L.Map.Sync');

const Surging = {
  version: "1.0.1",
  tiles_host: "//{s}.ss2tiles.climatecentral.org",
  //tiles_host: "http://d1tlo8un0042v1.cloudfront.net",
  // tiles_host: "http://ec2-54-167-185-137.compute-1.amazonaws.com",
  // TODO: get geocoder to work through cloudfront,
  // or use CNAME to load balanced servers.
  data_service: "http://ss2-balance-930902320.us-east-1.elb.amazonaws.com",
  mapbox_access_token: "pk.eyJ1IjoiY2xpbWF0ZWNlbnRyYWwiLCJhIjoiY2tndGxidGgwMWMzNzJ3bWxvY2M5bmV0dSJ9.So-X5Vyq640R6W6rz2_Ndw",
  campaign: 'SSRF-2.0'
};

Surging.LockIn =  {
  'time-horizon': [2015, 2050, 2100],
  scenarios: ['extreme-cuts', 'moderate-cuts', 'minor-cuts', 'unchecked', 'historic'],
  temperatures: ['warming-1.5', 'warming-2', 'warming-3', 'warming-4'],
  labels : {
    'extreme-cuts'    : 'Extreme carbon cuts',
    'moderate-cuts'   : 'Moderate carbon cuts',
    'minor-cuts'      : 'Minor carbon cuts',
    'unchecked'       : 'Unchecked pollution',
    'historic'        : 'Historic carbon pollution',
    'warming-1.5'     : '1.5° C Warming (2.7° F)',
    'warming-2'       : '2° C Warming (3.6° F)',
    'warming-3'       : '3° C Warming (5.4° F)',
    'warming-4'       : '4° C Warming (7.2° F)'
  },
  classes: {
    'extreme-cuts': 'extreme',
    'moderate-cuts': 'moderate',
    'minor-cuts': 'minor',
    'unchecked': 'unchecked',
    'historic': 'historic',
    'warming-1.5': 'extreme',
    'warming-2': 'moderate',
    'warming-3': 'minor',
    'warming-4': 'unchecked'
  },
  defaults: {
    temperatures: {
      a: 'warming-4',
      b: 'warming-2'
    },
    scenarios: {
      a: 'unchecked',
      b: 'extreme-cuts'
    }
  },
  deriveLabel: function(scenario) {
    //if (year === 2015) return this.labels.historic;
    return this.labels[scenario] || 'Unknown';
  },
  deriveLevel: function(scenario, year) {
    //if (year === 2015) return 1;
    if (scenario === 'historic') return 1;
    year = +year;

    switch (scenario) {
      case 'extreme-cuts':
        return (year === 2050) ? 2 : 3;
        break;

      case 'moderate-cuts':
        return (year === 2050) ? 4 : 5;
        break;

      case 'minor-cuts':
        return (year === 2050) ? 6 : 7;
        break;

      case 'unchecked':
        return (year === 2050) ? 8 : 9;
        break;

      case 'warming-1.5':
        return 10;
        break;

      case 'warming-2':
        return 11;
        break;

      case 'warming-3':
        return 12;
        break;

      case 'warming-4':
        return 13;
        break;

      default:
        return 1;
        break;
    }
  },

  validQuery: function(query) {
    if ((query.hasOwnProperty('compare') && query.compare === 'temperatures') &&
        (query.hasOwnProperty('scenario-a') && this.temperatures.indexOf(query['scenario-a']) > -1) &&
        (query.hasOwnProperty('scenario-b') && this.temperatures.indexOf(query['scenario-b']) > -1)) {
      return true;

    } else if ((query.hasOwnProperty('carbon-end-yr') && this['time-horizon'].indexOf(query['carbon-end-yr']) > -1) &&
        (query.hasOwnProperty('scenario-a') && this.scenarios.indexOf(query['scenario-a']) > -1) &&
        (query.hasOwnProperty('scenario-b') && this.scenarios.indexOf(query['scenario-b']) > -1)) {
      return true;
    }
    return false;
  }
};

Surging.NOAA2017 =  {
  scenarios: ['extreme_p17', 'extreme_p50', 'extreme_p83'],
  labels : {
    'extreme_p17'    : 'Extreme scenario (17th percentile)',
    'extreme_p50'    : 'Extreme scenario (50th percentile)',
    'extreme_p83'    : 'Extreme scenario (83rd percentile)',
  },
  classes: {
    'extreme_p17': 'extreme_p17',
    'extreme_p50': 'extreme_p50',
    'extreme_p83': 'extreme_p83',
  },
  defaults: {
    extreme: 'p50'
  },
  deriveLabel: function(scenario) {
    return this.labels[scenario] || 'Unknown';
  },
  deriveLevel: function(scenario) {
    switch (scenario) {
      case 'extreme_p17':
        return 1;
      case 'extreme_p50':
        return 2;
      case 'extreme_p83':
        return 3;
      default:
        return 1;
    }
  },

  validQuery: function(query) {
    return (query.hasOwnProperty('scenario') && this.scenarios.indexOf(query['scenario']) > -1);
  }
};

Surging.TileUrls = {
  satellite:              "//d1qr9crh9lmvuc.cloudfront.net/styles/v1/climatecentral/ckgqpdi6j5pyv1awyd9n8dknt/tiles/256/{z}/{x}/{y}?access_token=" + Surging.mapbox_access_token,
  // "hybrid" layer include protected in patterned form, and unprotected as solid
  waterLevelHybrid:       Surging.tiles_host + "/flooding/{z}/{x}/{y}.png",
  waterMask:              Surging.tiles_host + "/ocean_mask/{z}/{x}/{y}.png",
  // toner:                  "http://{s}.tile.stamen.com/toner/{z}/{x}/{y}.png",
  lockin:                 Surging.tiles_host + "/lockin/{z}/{x}/{y}.png",
  noaa2017:               Surging.tiles_host + "/noaa2017/{z}/{x}/{y}.png",
  tonerAndLevees:         Surging.tiles_host + "/toner-and-levees/{z}/{x}/{y}.png",
  tonerHillshade:         Surging.tiles_host + "/toner-hillshade/{z}/{x}/{y}.png",
  leveesAndBlueLabels:    Surging.tiles_host + "/levees-and-blue-labels/{z}/{x}/{y}.png",
  tonerHybridBlue:        Surging.tiles_host + "/toner-hybrid-blue/{z}/{x}/{y}.png",

  // data layers
  ethnicity:              Surging.tiles_host + "/ethnicity-dots/{z}/{x}/{y}.png",
  sovi:                   Surging.tiles_host + "/social_vulnerability/{z}/{x}/{y}.png",
  popd:                   Surging.tiles_host + "/population_density/{z}/{x}/{y}.png",
  property:               Surging.tiles_host + "/property/{z}/{x}/{y}.png",
  income:                 Surging.tiles_host + "/income/{z}/{x}/{y}.png"
};

/*
 * Surging.Stack is a configuration object for named composite "stacks".
 * Surging.Stack.aliases contains the actual named aliases. There are also
 * the following convenience methods:
 */
Surging.Stack = {
  // this is where named "stacks" live. each key/value pair creates a named
  // "stack", an array describes compositing operations for variable water levels.
  aliases: {},

  get: function(stackOrId) {
    if (typeof stackOrId === "string") {
      if (stackOrId in this.aliases) {
        return this.aliases[stackOrId];
      } else {
        throw new Error('No such stack "' + stackOrId + '"');
      }
    } else if (stackOrId instanceof Array) {
      return stackOrId;
    } else {
      throw new Error("Bad stack value: expected id or Array, got " + typeof stackOrId);
    }
  },

  set: function(stackId, stack) {
    this.aliases[stackId] = stack;
    return stack;
  },

  getId: function(stack) {
    for (var stackId in this.aliases) {
      if (this.aliases[stackId] === stack) return stackId;
    }
    return undefined;
  }
};

/*
 * Default named stacks!
 */

// "satellite" is the default stack
Surging.Stack.set("satellite", [
  {url: Surging.TileUrls.satellite},
  {url: Surging.TileUrls.leveesAndBlueLabels},
  {source: [
    {url: Surging.TileUrls.tonerAndLevees},
    {url: Surging.TileUrls.waterLevelHybrid, comp: "destination-out", bitmask: true, name: "flooding"},
    {url: Surging.TileUrls.waterLevelHybrid, comp: "source-over", bitmask: true, name: "flooding-color"},
    {url: Surging.TileUrls.waterMask, comp: "destination-out", bitmask: true, name: "waterMask"},
  ]}
]);

// "sovi" is the "Social vulnerability Index" data layer
Surging.Stack.set("sovi", [
  {url: Surging.TileUrls.satellite},
  {url: Surging.TileUrls.sovi},
  {url: Surging.TileUrls.leveesAndBlueLabels},
  {source: [
    {url: Surging.TileUrls.tonerAndLevees},
    {url: Surging.TileUrls.waterMask, comp: "destination-out", bitmask: true, name: "waterMask"},
    {url: Surging.TileUrls.waterLevelHybrid, comp: "destination-out", bitmask: true}
  ]},
]);

// "popd" is the "Population Density" data layer
Surging.Stack.set("popd", [
  {url: Surging.TileUrls.satellite},
  {url: Surging.TileUrls.popd},
  {url: Surging.TileUrls.leveesAndBlueLabels},
  {source: [
    {url: Surging.TileUrls.tonerAndLevees},
    {url: Surging.TileUrls.waterMask, comp: "destination-out", bitmask: true, name: "waterMask"},
    {url: Surging.TileUrls.waterLevelHybrid, comp: "destination-out", bitmask: true}
  ]},
]);

// "property" is the "Property Value Density" data layer
Surging.Stack.set("property", [
  {url: Surging.TileUrls.satellite},
  {url: Surging.TileUrls.property},
  {url: Surging.TileUrls.leveesAndBlueLabels},
  {source: [
    {url: Surging.TileUrls.tonerAndLevees},
    {url: Surging.TileUrls.waterMask, comp: "destination-out", bitmask: true, name: "waterMask"},
    {url: Surging.TileUrls.waterLevelHybrid, comp: "destination-out", bitmask: true}
  ]},
]);

// "income" is the "Income Level" data layer
Surging.Stack.set("income", [
  {url: Surging.TileUrls.satellite},
  {url: Surging.TileUrls.income},
  {url: Surging.TileUrls.leveesAndBlueLabels},
  {source: [
    {url: Surging.TileUrls.tonerAndLevees},
    {url: Surging.TileUrls.waterMask, comp: "destination-out", bitmask: true, name: "waterMask"},
    {url: Surging.TileUrls.waterLevelHybrid, comp: "destination-out", bitmask: true}
  ]},
]);

Surging.Stack.set("ethnicity", [
  {url: Surging.TileUrls.satellite},
  {url: "img/darkblue.png", alpha: 70},
  {url: Surging.TileUrls.ethnicity},
  {url: Surging.TileUrls.leveesAndBlueLabels},
  {source: [
    {url: Surging.TileUrls.tonerAndLevees},
    {url: Surging.TileUrls.waterMask, comp: "destination-out", bitmask: true, name: "waterMask"},
    {url: Surging.TileUrls.waterLevelHybrid, comp: "destination-out", bitmask: true}
  ]},
]);

Surging.Stack.set("lockin", [
  {url: Surging.TileUrls.satellite},
  {url: Surging.TileUrls.tonerHybridBlue},
  {source: [
    {url: Surging.TileUrls.tonerHillshade},
    {url: Surging.TileUrls.lockin, comp: "destination-out", bitmask: true, lockin: true},
    {url: Surging.TileUrls.lockin, comp: "source-over", bitmask: true, lockin: true, name: "flooding-color"},
    {url: Surging.TileUrls.waterMask, comp: "destination-in", bitmask: true, lockin: true, name: "waterMask"},
  ]}
]);

Surging.Stack.set("noaa2017", [
  {url: Surging.TileUrls.satellite},
  {url: Surging.TileUrls.leveesAndBlueLabels},
  {source: [
    {url: Surging.TileUrls.tonerAndLevees},
    {url: Surging.TileUrls.noaa2017, comp: "destination-out", bitmask: true},
    {url: Surging.TileUrls.noaa2017, comp: "source-over", bitmask: true, name: "flooding-color"},
    {url: Surging.TileUrls.waterMask, comp: "destination-in", bitmask: true, name: "waterMask"},
  ]}
]);

Surging.Map = L.Map.extend({
  statics: {
    // HTML canvas feature detection
    supported: function() {

      // initialize close button for browser upgrade warning
      $('#browserupgrade-close').on('click', function(evt){
        evt.preventDefault();
        $(this.parentNode).css('display','none');
      });

      // now perform the real test
      var canvas = document.createElement("canvas");
      try {
        var context = canvas.getContext("2d");
        return !!context.drawImage;
      } catch (err) {
        console.warn("no canvas support!");
        return false;
      }
    }
  },

  options: {
    center: null,
    zoom: 13,
    maxZoom: 16,
    minZoom: 4,
    waterLayer: {
      stack: "satellite",
    },
    attributionControl: false,
    inertia: false,
    scrollWheelZoom: false,
    keyboard: true,
    keyboardPanOffset: 256,
    hash: true
  },

  initialize: function(id, options) {
    var self = this;

    // var hashString = document.location.hash;
    // if (hashString.charAt(0) === '#') hashString = hashString.substr(1);
    // var incomingHash = L.Hash.parseHash(hashString);
    //
    // // check to see if we have an old SS1 URL
    // if (!incomingHash) {
    //   var parts = Surging.Util.QueryString.parse(hashString);
    //   if (parts.center) incomingHash = L.Hash.parseHash(parts.center);
    // }
    //
    // if (incomingHash.center) options.center = incomingHash.center;
    // if (incomingHash.zoom) options.zoom = incomingHash.zoom;
    // if (hashString.indexOf("presentation=1") !== -1) options.presentation = 1;

    L.Map.prototype.initialize.apply(this, arguments);
    // var s = this.addHash();

    this.options.composer = this.options.composer || composer;

    // Since the maps will be linked we will call hash in
    // first lockin map only for performance reasons.
    // We relink in `Surging.Map.linkMaps`
    if (this.options.lockin && this._hash) {
      this._hash.stopListening();
    }

    if (this.options.waterLayer) {
      var waterOptions = this.options.waterLayer;
      // convert a string to an options object with the value as its stack id
      if (typeof waterOptions === "string") {
        waterOptions = {stack: waterOptions};
      }

      waterOptions.composer = this.options.composer;

      this.waterLayer = new Surging.WaterLevelLayer(waterOptions).addTo(this);

      this.waterLayer.on("stackchange", this._onStackChange, this);

      if (this.options.lockin) {
        //...
      } else if (typeof this.options.waterLevel === "number") {
        this.setWaterLevel(this.options.waterLevel, false);
      }
    }

    if (this.options.inboundLink) {
      this.setInboundLink(this.options.inboundLink, !location.hash);
    }

    // set level and layer via location hash
    var map = this;
    var queryFrag = location.hash.substr(location.hash.indexOf('?'));
    var parsed = Surging.Util.QueryString.parse(queryFrag);
    this.parsed = parsed;

    // Locked in maps will send org in linkedMaps
    if(parsed.embedOrg && !this.options.lockin) {
      if (typeof ga !== 'undefined') {
        ga('send', 'event', Surging.campaign, "Embed Tracking: " + parsed.embedOrg);
        ga(Surging.campaign + '.send', 'event', "embed", "initialize-org", parsed.embedOrg);
      }
    }

    if (parsed.show) {
      this.setStack(parsed.show, false);
    }

    if (parsed.level && !this.options.lockin) {
      this.setWaterLevel(parsed.level, false);
    }

    if (parsed.unit && !this.options.lockin) {
      this.setWaterUnit(parsed.unit, false);
    }

    if (parsed.pois == "show") {
      this.poisState = "show";
    } else {
      this.poisState = "hide";
    }

    if (parsed.projections && parsed.projections.split && parsed.projections.split('-').length === 3) {
      this._projectionState = parsed.projections;
    } else {
      this._projectionState = null;
    }

    if (this.options.lockin) {
      // If there is a valid query don't set lockin map state here
      // let Surging.Map.linkMaps handle it
      if (!Surging.LockIn.validQuery(map.parsed || {})) {
        var lvl = Surging.LockIn.deriveLevel(this.options.lockin.scenario, this.options.lockin['time-horizon']);
        waterOptions.composer.level(lvl);
        this.setWaterLevel(lvl, false);
        this.setLockin(this.options.lockin.scenario, this.options.lockin.compare, this.options.lockin['time-horizon'], true);
      }
    }

    if (this.options.noaa2017) {
      var lvl;
      if (Surging.NOAA2017.validQuery(map.parsed || {})) {
        lvl = Surging.NOAA2017.deriveLevel(map.parsed.scenario);
        this.options.noaa2017.scenario = map.parsed.scenario;
      } else {
        lvl = Surging.NOAA2017.deriveLevel(this.options.noaa2017.scenario);
      }
      waterOptions.composer.level(lvl);
      this.setWaterLevel(lvl, false);
    }

    //Override formatHash
    if (this._hash) {
      var self = this;
      this._hash.formatHash = function(map, lockins) {
        var center = map.getCenter(),
            zoom = map.getZoom(),
            precision = Math.max(0, Math.ceil(Math.log(zoom) / Math.LN2));

        return "#" + [zoom,
              center.lat.toFixed(precision),
              center.lng.toFixed(precision)
            ].join("/") + Surging.Util.QueryString.format(self.getStateOptions(map, lockins));
      };
    }

  },

  getStateOptions: function(map, lockins) {
    if (this.options.lockin) {
      lockins = lockins || Surging.LockIn.maps;
      if (!lockins  && lockins.length) return {};
      var state = {
        'compare': lockins[0].options.lockin.compare,
        'carbon-end-yr': lockins[0].options.lockin['time-horizon'],
        'scenario-a': lockins[0].options.lockin.scenario,
        'scenario-b': lockins[1].options.lockin.scenario
      };
      if (lockins[0].options.presentation) {
        state['presentation'] = lockins[0].options.presentation;
      }
      return state;
    } else if (this.options.noaa2017) {
      return {
        'scenario': map.options.noaa2017.scenario,
      };
    } else {
      return {
        'show':  Surging.Stack.getId(map.getStack()),
        'projections': map._projectionState,
        'level': map.getWaterLevel(),
        'unit':  map.getWaterUnit(),
        'pois':  map.poisState
      };
    }
  },

  setProjectionsState: function(state, updateHash) {
    this._projectionState = state;

    if (this._hash && updateHash) {
      this._hash.onMapMove();
    }
  },

  getProjectionsState: function() {
    return this._projectionState || false;
  },

  setCenter: function(latlng, forceReset) {
    var o = {};
    if (forceReset) o.reset = true;
    return this.setView(latlng, this.getZoom(), o);
  },

  getWaterLevel: function() {
    return this.waterLayer.getLevel();
  },

  getWaterUnit: function() {
    return this.waterLayer.getUnit();
  },

  setWaterLevel: function(level, updateHash) {
    if (this.getWaterLevel() !== level) {

      this.waterLayer.setLevel(level);
      level = this.getWaterLevel();
      this.fireEvent("waterlevel", level);

      if (this._hash && updateHash) {
        this._hash.onMapMove();
      }
    }
    return this;
  },

  setWaterUnit: function(unit, updateHash) {
    this.waterLayer.setUnit(unit);
    this.fireEvent("waterunit", unit);

    if (this._hash && updateHash) {
      this._hash.onMapMove();
    }

    return this;
  },

  onLockinChange: function(scenario, year) {
    if (!this.options.lockin) return this;
    var lvl = Surging.LockIn.deriveLevel(scenario, year);
    this.options.composer.level(lvl);
    this.waterLayer.setLevel(lvl);
    this.fire('move');
  },

  setLockin: function(scenario, compareMode, year, updateHash) {
    if (!this.options.lockin) return this;
    if (this.firstPass &&
        this.options.lockin.compare === compareMode &&
        this.options.lockin.scenario === scenario &&
        this.options.lockin['time-horizon'] === year) return this;

    this.firstPass = true;

    this.options.lockin.compare = compareMode;
    this.options.lockin.scenario = scenario;
    this.options.lockin['time-horizon'] = year;

    // TODO: finalize changes with Risk Finder, keep codebase
    //    as close as possible to surging_seas_maps so that code can be reused in the future
    // var label = $(this._container).parent().find('.map-label');
    // var wrapper = $(this._container).parent().find('.map-label-wrapper');
    // label.text(Surging.LockIn.deriveLabel(scenario));
    // wrapper[0].className = "map-label-wrapper " + (Surging.LockIn.classes[scenario] || '');

    if (this._hash && updateHash) {
      //this.fire('move');
      this._hash.onMapMove();
    }

    return this;
  },

  setNOAA2017: function(scenario, updateHash) {
    if (!this.options.noaa2017) return this;
    if (this.firstPass &&
        this.options.lockin.scenario === scenario) return this;

    this.firstPass = true;

    this.options.noa2017.scenario = scenario;

    var label = $(this._container).parent().find('.map-label');
    var wrapper = $(this._container).parent().find('.map-label-wrapper');
    label.text(Surging.NOAA2017.deriveLabel(scenario));
    wrapper[0].className = "map-label-wrapper " + (Surging.NOAA2017.classes[scenario] || '');

    if (this._hash && updateHash) {
      //this.fire('move');
      this._hash.onMapMove();
    }

    return this;
  },

  getStack: function() {
    return this.waterLayer.getStack();
  },

  setStack: function(stackOrId, updateHash) {
    this.waterLayer.setStack(stackOrId);
    stackOrId = Surging.Stack.getId(this.getStack());
    this.fireEvent("stackchange", {
      stack: stackOrId
    });

    if (this._hash && updateHash) {
      this._hash.onMapMove();
    }

    return this;
  },

  // echo "stackchange" events, but normalize to ids
  _onStackChange: function(e) {
    var stackOrId = e.stack;
    // console.log("water layer [stackchange]", stackOrId, e);
    if (typeof stackOrId === "string") {
      this.fireEvent("stackchange", {
        stack: stackOrId
      });
    } else {
      var stackId = Surging.Stack.getId(stackOrId);
      this.fireEvent("stackchange", {
        stack: stackId || stackOrId
      });
    }
  },

  // this is the public function for setting the inbound link options
  setInboundLink: function(options, setCenter) {
    if (!options) return this;
    else if (typeof options === "string") {
      options = Surging.Util.QueryString.parse(options);
    }

    var center = this._updateInboundLink(options);
    if (center) {
      if (setCenter) {
        this.setCenter(center, true);
      }
    }
    return this;
  },

  _updateInboundLink: function(options) {
    var center,
        label = options.label,
        feature;

    if (options.point) {

      var point = options.point.split(","),
          lat = +point[0],
          lng = +point[1];
      center = [lat, lng];

    } else if (options.area) {

      // TODO demonstrate how an area might be displayed

    } else if (options.bbox) {

      var bbox = options.bbox.split(",");
      if (bbox.length !== 4) {
        console.warn("invalid bbox:", bbox.join(", "));
        return;
      }

      var north = Math.max(+bbox[0], +bbox[2]),
          west =  Math.min(+bbox[1], +bbox[3]),
          south = Math.min(+bbox[0], +bbox[2]),
          east =  Math.max(+bbox[1], +bbox[3]),
          ring = [
            [north, west],
            [north, east],
            [south, east],
            [south, west],
            [north, west]
          ];

      center = [
        south + (north - south) / 2,
        west + (east - west) / 2
      ];

      feature = new Surging.InboundPolygon([ring])
          .addTo(this);
    }

    if (center) {

      var map = this,
          content = (label || String(center)).replace(/([<&>])/g, function(match, chr) {
            switch (chr) {
              case "<": return "&lt;";
              case ">": return "&gt;";
              case "&": return "&amp;";
            }
          }),
          marker = new Surging.InboundLinkMarker(center, {
            icon: new Surging.InboundLinkIcon({
              html: '<span>' + content + '</span>'
            })
          });

      this.addLayer(marker);

      // listen for close link clicks
      d3.select(marker._icon)
          .select("a.close")
          .on("click", function() {
            if (feature) map.removeLayer(feature);
            map.removeLayer(marker);
            d3.event.preventDefault();
            d3.event.stopPropagation();
          });
    }

    return center;
  }
});

Surging.Map.linkMaps = function(mapInstances) {
  var self = this;
  // var zoomIn, zoomOut;

  Surging.LockIn.maps = mapInstances;

  this.changeDefer = 500;

  // var settingsForm = $('#settings-panel form');

  var currentCompareMode = 'temperatures';
  var currentSettings = {
    temperatures: {
      a:Surging.LockIn.defaults.temperatures.a,
      b:Surging.LockIn.defaults.temperatures.b
    },
    scenarios: {
      a:Surging.LockIn.defaults.scenarios.a,
      b:Surging.LockIn.defaults.scenarios.b
    }
  };

  // compareSelector.on(function(idx, val){
  //   if (val === currentCompareMode) return;
  //   compareSelectorHandler(val, false);
  // });

  // function compareSelectorHandler(val, force) {
  //   if (val === currentCompareMode && !force) return;
  //   if (currentCompareMode) settingsForm.removeClass(currentCompareMode);
  //   settingsForm.addClass(val);

  //   currentCompareMode = val;

  //   var formA = currentSettings[currentCompareMode].a,
  //       formB = currentSettings[currentCompareMode].b;

  //   if (formA && formB) {
  //     mapInstances[0].options.lockin.dropdown.setIndexByValue(formA);
  //     mapInstances[1].options.lockin.dropdown.setIndexByValue(formB);
  //   }
  // }

  // function updateCurrentSettings(mode, side, val) {
  //   try {
  //     currentSettings[mode][side] = val;
  //   } catch(e) {
  //     console.warn('Could not update current settings: (%s, %s, %s)', mode, side, val);
  //   }
  // }

  // function constrainZoom(z) {
  //   zoomIn.classed('leaflet-disabled', false);
  //   zoomOut.classed('leaflet-disabled', false);
  //
  //   if (z >= mapInstances[0].getMaxZoom()) {
  //     zoomIn.classed('leaflet-disabled', true);
  //     return mapInstances[0].getMaxZoom();
  //   }
  //   if (z <= mapInstances[0].getMinZoom()) {
  //     zoomOut.classed('leaflet-disabled', true);
  //     return mapInstances[0].getMinZoom();
  //   }
  //   return z;
  // }

  // function onZoomClick(dir) {
  //   var z = mapInstances[0].getZoom();
  //   var c = mapInstances[0].getCenter();
  //   z += (dir === 1) ? 1 : -1;
  //   z = constrainZoom(z);
  //   mapInstances[0].setView(c, z, {animate: false});
  // }

  // this.updateHash = function(caller, force) {
  //   caller = caller || mapInstances[0];
  //   var hash = caller._hash.formatHash(caller, mapInstances);
  //   caller._hash.setHash(hash, force);
  // };
  //
  // this.getHash = function() {
  //   return mapInstances[0]._hash.formatHash(mapInstances[0], mapInstances);
  // };
  //
  // this.setHash = function(hash, force) {
  //   mapInstances[0]._hash.setHash(hash, force);
  // };

  this.setViews = function(center, zoom) {
    mapInstances[0].setView(center, zoom, {animate: false});
    //mapInstances[1].setView(center, zoom, {animate: false});
  }

  // set initial form values
  // function updateSettingsForm() {
  //   compareSelector.setIndexByValue(currentCompareMode);
  //   mapInstances[0].options.lockin.dropdown.setIndexByValue(mapInstances[0].options.lockin.scenario);
  //   mapInstances[1].options.lockin.dropdown.setIndexByValue(mapInstances[1].options.lockin.scenario);
  //   yearSelector.setIndexByValue(mapInstances[1].options.lockin['time-horizon']);
  //
  //   $('body').toggleClass('historic', (mapInstances[0].options.lockin['time-horizon'] === 2015));
  // }

  // if (mapInstances[0].parsed && mapInstances[0].parsed.embedOrg) {
  //   if (typeof ga !== 'undefined') {
  //     ga('send', 'event', Surging.campaign, "Embed Tracking: " + mapInstances[0].parsed.embedOrg);
  //     ga(Surging.campaign + '.send', 'event', "embed", "initialize-org", mapInstances[0].parsed.embedOrg);
  //   }
  // }

  // set map
  // function updateMapLockinState(map,scenario,year) {
  //   if (map.options.lockin.scenario !== scenario ||
  //       map.options.lockin['time-horizon'] != year) {
  //
  //     map.onLockinChange(scenario, year);
  //     map.setLockin(scenario, currentCompareMode, year, false);
  //   }
  // }

  // form handler
  // settingsForm.submit(function(evt){
  //   evt.preventDefault();
  //   var left    = mapInstances[0].options.lockin.dropdown.getValue(),
  //       right   = mapInstances[1].options.lockin.dropdown.getValue(),
  //       compare = compareSelector.getValue(),
  //       yr      = +yearSelector.getValue();
  //
  //   if (yr != mapInstances[0].options.lockin['time-horizon']) {
  //     if (typeof ga !== 'undefined') {
  //       ga('send', 'event', Surging.campaign, 'Lockin time-horizon change: ' +  yr);
  //       ga(Surging.campaign + '.send', 'event', 'time-horizon', 'configure', yr);
  //     }
  //   }
  //
  //   if (left !== mapInstances[0].options.lockin.scenario) {
  //     if (typeof ga !== 'undefined') {
  //       ga('send', 'event', Surging.campaign, 'Lockin scenario 1 change: ' +  left);
  //       ga(Surging.campaign + '.send', 'event', 'scenario-1', 'configure', left);
  //     }
  //   }
  //
  //   if (right !== mapInstances[1].options.lockin.scenario) {
  //     if (typeof ga !== 'undefined') {
  //       ga('send', 'event', Surging.campaign, 'Lockin scenario 2 change: ' +  right);
  //       ga(Surging.campaign + '.send', 'event', 'scenario-2', 'configure', right);
  //     }
  //   }
  //
  //   if (currentCompareMode !== compare) {
  //     if (typeof ga !== 'undefined') {
  //       ga('send', 'event', Surging.campaign, 'Compare mode changed: ' +  right);
  //       ga(Surging.campaign + '.send', 'event', 'compare-mode', 'configure', compare);
  //     }
  //   }
  //
  //   //currentCompareMode = compare;
  //   updateCurrentSettings(currentCompareMode, 'a', left);
  //   updateCurrentSettings(currentCompareMode, 'b', right);
  //
  //   /*
  //    if (left === 'historic' || right === 'historic') {
  //    mapInstances[0].options.lockin.dropdown.setIndexByValue('historic');
  //    mapInstances[1].options.lockin.dropdown.setIndexByValue('historic');
  //    left = right = 'historic';
  //    }*/
  //
  //   updateMapLockinState(mapInstances[0], left, yr);
  //   updateMapLockinState(mapInstances[1], right, yr);
  //   // self.updateHash();
  //
  //   if (Surging.closeModal) Surging.closeModal();
  // });

  // intialize the map instances
  mapInstances.forEach(function(map,i) {
    map.linkedID_ = i;
    if (map._hash) {
      map._hash.allowUpdates = false;
    }

    // update compare settings for each map
    if (Surging.LockIn.validQuery(map.parsed || {})) {
      // this is a little weird
      if (i === 0) {
        // compareSelectorHandler(map.parsed.compare, true);
        // updateCurrentSettings(map.parsed.compare, 'a', map.parsed['scenario-a']);
        // map.onLockinChange(map.parsed['scenario-a'], map.parsed['carbon-end-yr']);
        map.setLockin(map.parsed['scenario-a'], map.parsed.compare, map.parsed['carbon-end-yr'], true);
      } else {
        // updateCurrentSettings(map.parsed.compare, 'b', map.parsed['scenario-b']);
        // map.onLockinChange(map.parsed['scenario-b'], map.parsed['carbon-end-yr']);
        map.setLockin(map.parsed['scenario-b'], map.parsed.compare, map.parsed['carbon-end-yr'], true);
      }
    }
  });

  // sync maps
  mapInstances[0].sync(mapInstances[1]);
  mapInstances[1].sync(mapInstances[0]);

  // // handle zoom changes
  // mapInstances[0].on('zoomend',function(){
  //   constrainZoom(mapInstances[0].getZoom());
  // });

  // // handle move end
  // var updateHashDebounced = Surging.Util.debounce(this.updateHash, 250, this);
  // mapInstances[0].on('moveend',function(){
  //   updateHashDebounced(mapInstances[0]);
  // });

  this.setVertical = function(isVertical) {
    _linkedMapContainer.classed('vertical', isVertical);
    mapInstances[0].invalidateSize(false);
    mapInstances[1].invalidateSize(false);
  }

  // handle window resize
  var verticalOrientation;
  var _window = $(window);
  var _linkedMapContainer = d3.select('.linked-maps');
  var bodyElm = d3.select('body');

  function calcAspectRatio() {
    var container = $('.linked-maps');
    var w = container.width(),
        h = container.height(),
        isVert = (w > h || w == h) ? true : false;

    if (isVert === verticalOrientation) return;
    verticalOrientation = isVert;

    bodyElm.classed('zoom-btn-horzy', !isVert);
    _linkedMapContainer.classed('vertical', isVert);
    mapInstances[0].invalidateSize(false);
    mapInstances[1].invalidateSize(false);
  }

  function _onWindowResize() {
    calcAspectRatio();
  }

  // d3.select(window).on('resize', Surging.Util.debounce(_onWindowResize, 250, this));

  // add zoom controls
  // if (zoomControls) {
  //   var controls = d3.select(zoomControls);
  //   zoomIn = controls.select('.leaflet-control-zoom-in');
  //   zoomOut = controls.select('.leaflet-control-zoom-out');
  //
  //   zoomIn.on('click', function() {
  //     d3.event.preventDefault();
  //     onZoomClick(1);
  //   });
  //
  //   zoomOut.on('click', function() {
  //     d3.event.preventDefault();
  //     onZoomClick(0);
  //   });
  //
  //   // init zoom controls
  //   constrainZoom(mapInstances[0].getZoom());
  // }

  // init settings form
  // updateSettingsForm();

  // trigger orientation of maps columns
  // _onWindowResize();

  // trigger settings
  mapInstances[0].fire('move');

  return this;
};


Surging.InboundLinkIcon = L.DivIcon.extend({
  options: {
    iconUrl: null,
    iconSize: [0, 30],
    iconAnchor: [0, 15],
    className: "inbound-link-marker",
    close: true
  },

  // always add the close link
  createIcon: function() {
    var div = L.DivIcon.prototype.createIcon.call(this);
    if (this.options.close) {
      d3.select(div).append("a")
          .attr("class", "close")
          .html("&times;");
    }
    return div;
  }
});

Surging.AboutHelper = L.Class.extend({
  links: [],
  selector: 'abouttarget',
  currentHash: null,
  callbackFn: function() {},
  linkedMaps: null,

  initialize: function(callback, linkedMaps) {
    var that = this;
    this.linkedMaps = linkedMaps;
    if (typeof callback === 'function') this.callbackFn = callback;

    this.links = $('[data-' + this.selector + '*=]');
    this.links.on('touchstart click', function(evt){
      evt.preventDefault();
      evt.stopPropagation();
      var target = this.getAttribute('data-' + that.selector);
      that.callbackFn(target);
      that._map._hash.setHash('#' + target, true);
    });

    return this;
  },

  addTo: function(map) {
    this.onAdd.call(this, map);
    return this;
  },

  onAdd: function(map) {
    this._map = map;
  },

  onRemove: function(map) {
    this._map = null;
    this.links = null;
    this.linkedMaps = null;
  },

  close: function() {
    var hash;
    if (!this.linkedMaps) {
      hash = this._map._hash.formatHash(this._map);
    } else {
      hash = this.linkedMaps.getHash();
    }

    this._map._hash.setHash(hash, true);
  }
});

Surging.DownloadService = {
  BASE_URL: "//ssws.climatecentral.org",
  posting: false,

  resetForm: function(div_id) {
    $(div_id).removeClass('sent');
    $(div_id + '.contact_form input, ' + div_id + ' .contact_form textarea')
        .not(':button, :submit, :reset, :hidden')
        .val('');
  },

  postForm: function (div_id) {
    if (this.posting) return false;
    this.posting = true;

    var that = this;
    var inputs = $(div_id + ' .contact_form input, ' + div_id + ' .contact_form textarea, ' + div_id + ' .contact_form select');
    var formData = {};
    $.each(inputs, function (_, input) {
      formData[input.name] = input.value;
    });
    var mapURL = window.location.origin + (window.location.search === "" ? "?screenshot" : window.location.search + "&screenshot") + window.location.hash;
    if (div_id === "#screenshot-png") {
      formData["phones[2].Label"] = "Screenshot URL";
      formData["phones[2].Value"] = window.location.href;
      var screenshotURL = this.BASE_URL + "/screenshot" +
          "?width=" + $(window).width() +
          "&height=" + $(window).height() +
          "&url=" + encodeURIComponent(mapURL);
      this.downloadFile(screenshotURL, 'surgingseas.png');
    } else if (div_id === "#screenshot-ppt") {
      formData["phones[2].Label"] = "Screenshot URL";
      formData["phones[2].Value"] = window.location.href;
      var screenshotURL = this.BASE_URL + "/screenshot" +
          "?width=1024" +
          "&height=820" +
          "&format=pptx" +
          "&url=" + encodeURIComponent(mapURL);
      this.downloadFile(screenshotURL, 'surgingseas.pptx');
    } else if (div_id === "#getmoredata") {
      formData["phones[2].Label"] = "Tidegauge DL";
      formData["phones[2].Value"] = $("[data-gaugeid]")[0].getAttribute("data-download-url");
      this.downloadFile(formData["phones[2].Value"], formData["phones[2].Value"].split("/").pop());
    } else if (div_id === "#ge-kml") {
      var downloadURL;
      var filename;
      if (formData["phones[0].Value"] === "Surging Seas Mapping Choices KML") {
        downloadURL = "http://downloads.climatecentral.org/mappingchoices/assets/slr_temperature_lockin.kml";
        filename = "slr_temperature_lockin.kml";
      } else {
        downloadURL = "http://downloads.climatecentral.org/mappingchoices/assets/slr_water_levels.kml";
        filename = "slr_water_levels.kml";
      }
      this.downloadFile(downloadURL, filename);
    }
    $(div_id).removeClass('sent').addClass('sent');

    $.post(this.BASE_URL + "/create-contact", formData, function(resp) {
      if (!(resp.success)) {
        console.error("Error creating contact");
      }

      that.posting = false;
    });
  },

  downloadFile: function (url, filename) {
    var link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    // Open as a file download (in Chrome and Firefox); fall back to viewing in new window in IE.
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }
};


Surging.Analytics = {
  onClick: function(evt) {
    var attr = this.getAttribute('data-analytics');
    if (typeof ga !== 'undefined' && attr) {
      ga('send', 'event', Surging.campaign, attr);
    }
  },

  on: function() {
    $("[data-analytics]").on('click', this.onClick);
  },

  off: function() {
    $("[data-analytics]").off('click', this.onClick);
  }
};

Surging.BoundsWatcher = L.Class.extend({
  defaults: {
    usa: [[18.91172, -179.150558], [71.441048, -66.940643]],
    continentalUSA: [[24.94932, -125.001106], [49.59037, -66.93264]]
  },
  _bounds: null,
  _useGeoJson: false,
  status: null,

  initialize: async function(bounds, closestLineString) {
    var that = this;

    if (bounds in this.defaults) { // use a default
      this._bounds = L.latLngBounds(this.defaults[bounds]);
    } else if ($.isArray(bounds)) { // if Array, assume it's formatted for a Leaflet LatLngBounds Object
      this._bounds = L.latLngBounds(bounds);
    } else { // assume it's a string pointing to a geoJSON file
      const data = await d3.json(bounds);

      if (!closestLineString) {
        that.initGeoJsonWatch(data, null);
      } else {
        const linestring = await d3.json(closestLineString);
        that.initGeoJsonWatch(data, linestring);
      }
    }

    return this;
  },

  addTo: function(map) {
    this.onAdd.call(this, map);
    return this;
  },

  onAdd: function(map) {
    this._map = map;
    this._watch();
    this._map.on('moveend',this._watch, this);
  },

  onRemove: function(map) {
    this._bounds = null;
    map.off('moveend',this._watch, this);
    this._map = null;
  },

  initGeoJsonWatch: function(data, linestring) {
    this._useGeoJson = true;
    this._bounds = data;
    this._linestring = linestring;
    if (this._map) this._watch();
  },

  getClosestByPolygon: function(pt) {
    if (!this._useGeoJson) {
      console.warn('Method only works for GeoJSON features.');
      return pt;
    }
    var verts = turf.explode(this._bounds);
    var point = {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "type": "Point",
        "coordinates": [pt.lng, pt.lat]
      }
    };
    var closest = turf.nearest(point, verts);
    var center = turf.centroid(closest);
    return [center.geometry.coordinates[1], center.geometry.coordinates[0]];
  },

  getClosestByLineString: function(pt) {
    if (!this._linestring) {
      console.warn('Method only works for linestring features.');
      return pt;
    }
    var point = {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "type": "Point",
        "coordinates": [pt.lng, pt.lat]
      }
    };
    var closest = turf.pointOnLine(this._linestring.features[0], point);
    return [closest.geometry.coordinates[1], closest.geometry.coordinates[0]];
  },

  resetStatus: function() {
    this.status = null;
  },

  _watch: function() {
    if (!this._bounds) return;
    var contained = false;

    if (this._useGeoJson) {
      var that = this;
      var bds = this._map.getBounds();
      var bbox = [bds.getEast() ,bds.getSouth(), bds.getWest(), bds.getNorth()];
      var poly = turf.bboxPolygon(bbox);
      this._bounds.features.forEach(function(f){
        var intersection = turf.intersect(poly, f);
        if (intersection) contained = true;
      });
    } else {
      contained = this._bounds.contains(this._map.getCenter());
    }

    if (contained !== this.status) {
      this.status = contained
      this._map.fire('boundschange', {'status': this.status});
    }

  }
});

Surging.InboundPolygon = L.Polygon.extend({
  options: {
    color: "#ffcb64",
    fill: null,
    opacity: 1,
    weight: 5
  }
});

Surging.InboundLinkMarker = L.Marker.extend({
  options: {
    icon: new Surging.InboundLinkIcon(),
    clickable: true
  }

  // TODO: close link?
});


Surging.TileLayer = L.TileLayer.extend({
  statics: {
    layerTemplate: Surging.tiles_host + "/{layer}/{z}/{x}/{y}.{format}",
    defaults: {
      subdomains: "abcd",
      format: "png"
    }
  },

  options: {
    /* "If true, all the tiles that are not visible after panning are removed
     * (for better performance). true by default on mobile WebKit, otherwise
     * false." */
    unloadInvisibleTiles: true,
    /* "If true, all the tiles that are not visible after panning are placed
     * in a reuse queue from which they will be fetched when new tiles become
     * visible (as opposed to dynamically creating new ones). This will in
     * theory keep memory usage low and eliminate the need for reserving new
     * memory whenever a new tile is needed." */
    reuseTiles: true,
    // use empty images to more easily identify 404 tiles
    errorTileUrl: L.Util.emptyImageUrl
  },

  initialize: function(url, options) {
    // merge in the defaults
    options = L.extend({}, Surging.TileLayer.defaults, options);
    L.Util.setOptions(this, options);
    this.setUrl(url);
  },

  setUrl: function(url) {
    // if this looks like a layer name, run it through the layer template
    if (url.substr(0, 4) !== "http") {
      url = Surging.TileLayer.layerTemplate.replace(/{layer}/g, url);
    }
    return L.TileLayer.prototype.setUrl.call(this, url);
  }
});


Surging.CompositeLayer = L.TileLayer.extend({
  options: {
    stack: [],
    unloadInvisibleTiles: true
  },

  composer_: null,

  initialize: function(options) {
    L.TileLayer.prototype.initialize.call(this, options);

    this.composer_ = options.composer;

    this.setStack(this.options.stack);
  },

  createTile: function(coords) {
    // create a <canvas> element for drawing
    var tile = L.DomUtil.create('canvas', 'leaflet-tile');

    // setup tile width and height according to the options
    var size = this.getTileSize();
    tile.width = size.x;
    tile.height = size.y;

    const stack = tile.stack = this._createTileStack(coords);

    var self = this;
    var loader = tile.loader = this.composer_.queue()
        .load(stack, function(error, _stack, layers) {
          // DON'T DO ANYTHING IF THIS IS THE WRONG STACK!
          // (prevents an unaborted load from drawing onto a tile with a new stack)
          if (stack !== _stack) return;
          if (error) {
            console.warn("composite load error:", error, stack, coords);
            tile.classList.add("error");
          }
          tile.loader = null;
          self.composer_.compose(stack, tile);
        });
        
    return tile;
  },

  getStack: function() {
    return this._stack;
  },

  setStack: function(stackOrId) {
    this._stack = Surging.Stack.get(stackOrId);
    this.fireEvent("stackchange", {
      stack: this._stack
    });

    // TODO: Will still flicker between changing datasets - not ideal.
    this.redraw();

    return this;
  },

  _createTileStack: function(coord) {
    var getTileUrl = L.Util.bind(this.getTileUrl, this);
    function dupeStack(stack) {
      return stack.map(function(layer) {
        var layer = L.extend({}, layer);
        if (Array.isArray(layer.source)) {
          layer.source = dupeStack(layer.source);
        } else {
          layer.url = getTileUrl(layer.url, coord);
        }
        return layer;
      });
    }
    return dupeStack(this._stack);
  },

  getTileUrl: function(url, coord) {
    if (url.indexOf("{s}") > -1) {
      var subd = coord.subdomains || this.options.subdomains || "",
          index = (coord.x + coord.y + coord.z) % subd.length;
      url = url.replace("{s}", Array.isArray(subd)
          ? subd[index] || ""
          : subd.charAt(index));
    }
    return url.replace(/{(\w+)}/g, function(match, key) {
      return coord[key] || "";
    });
  },

  eachTile: function(callback) {
    for (var t in this._tiles) {
      if (this._tiles.hasOwnProperty(t))
        callback.call(this, this._tiles[t]);
    }
  },
});


Surging.WaterLevelLayer = Surging.CompositeLayer.extend({
  options: {
    // current water level
    level: 5,
    // minimum level
    minLevel: 1,
    // maximum level
    maxLevel: 10,
    // current water unit
    unit: 'feet',
    // set this to true if you want lots of stuff in your console
    debug: false
  },

  initialize: function(options) {
    Surging.CompositeLayer.prototype.initialize.apply(this, arguments);
    // intialize the water level
    this.setLevel(this.options.level);
  },

  // get the current water level
  getLevel: function() {
    return this.options.level;
  },

  getUnit: function() {
    return this.options.unit;
  },

  setStack: function(stackOrId) {
    if (stackOrId !== this._lastStack) {
      this._lastStack = stackOrId;
    }
    return Surging.CompositeLayer.prototype.setStack.call(this, stackOrId);
  },

  // load a single tile with the given template URL
  loadTile: function(tile, template, coord) {
    var url = this.getTileUrl(template, coord),
        ctx = tile.getContext("2d");
    if (url) {
      tile.setAttribute("data-url", url);
      tile.loader = this.composer_.load.image(url, function(error, image) {
        tile.loader = null;
        if (!error) {
          ctx.drawImage(image, 0, 0);
        }
      });
    } else {
      ctx.clearRect(0, 0, tile.width, tile.height);
    }
  },

  // set the current water level, and redraw the layer
  setLevel: function(level) {
    this.options.level = level;
    this.redraw();
  },

  setUnit: function(unit) {
    this.options.unit = unit;
  }
});

Surging.FindMe = L.Class.extend({
  options: {
    search: {},
    searchService: null
  },

  initialize: function(map, options) {
    this._map = map;
    this._searchService = this.options.searchService
        || new Surging.SearchService(this.options.search);
  },

  findByMapCenter: function(query) {
    if (!query) return that._map.fire('findme-error', {error: 'No query', locations: null});

    var that = this;
    var c = this._map.getCenter();
    if (this._request) this._request.abort();
    return this._request = this._searchService.search(query, function(error, response) {
      if (!error) {
        var name = response.features[0].properties.name;
        var region = response.features[0].properties.region;
        var country_a = response.features[0].properties.country_a;
        var country = response.features[0].properties.country;
        var placename;
        if (country_a === "USA") {
          placename = name + ", " + region;
        } else {
          placename = name + ", " + country;
        }
        var locations = [{
          name: placename,
          latitude: response.features[0].geometry.coordinates[1],
          longitude: response.features[0].geometry.coordinates[0]
        }];
      }

      if(error) return that._map.fire('findme-error', {error: error, locations: null});
      that._map.fire('findme-found', {error: null, locations: locations});
    });
  },

  onRemove: function(map) {
    if (this._request) this._request.abort();
    this._searchService = null;
    this._map = null;
  }

});

Surging.SearchService = L.Class.extend({
  options: {
    //url: Surging.data_service + "/search?q={q}&w={w}&h={h}",
    url: "https://search.mapzen.com/v1/search?text={q}&api_key=search-dcOYCwg&size=1",
    jsonp: false
  },

  search: function(query, callback) {
    var url = (typeof query === "object") ? this._getUrl(query) : this._getUrl({q: query});
    return this.options.jsonp ? d3.jsonp(url).then(callback) : d3.json(url).then(callback);
  },

  _getUrl: function(params) {
    return this.options.url.replace(/{(\w+)}/g, function(str, key) {
      return (key in params) ? params[key] : str;
    });
  }
});

Surging.ToggleContainer = L.Control.extend({
  options: {
    position: "bottomleft",
  },

  buttons: [],
  includes: L.Evented,

  globalRestricted: false,

  onAdd: function (map) {
    this._map = map;

    var container = L.DomUtil.create('div', 'surging-control-container open');
    this.container = d3.select(container);

    var table = L.DomUtil.create('table', 'surging-control-inner', container);

    var content = L.DomUtil.create('tr', 'contents', table);
    L.DomUtil.create('td', '', content);
    var contentWrapper = L.DomUtil.create('td', 'content-wrapper', content);

    this.content = d3.select(content);

    var btnContainer = L.DomUtil.create('tr', 'buttons', table);

    var left = L.DomUtil.create('td', 'side left', btnContainer);

    var rightSide = L.DomUtil.create('td', 'side right', btnContainer);

    var buttonColumn = L.DomUtil.create('div', 'buttons-container group', rightSide);

    var noaa = L.DomUtil.create('div', 'noaa-msg', rightSide);
    var noaaLink = d3.select(noaa)
        .attr('id', 'noaa-link')
        .attr('data-abouttarget', 'noaa')
        .append('a')
        .on('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
        })
        .attr('href', 'http://coast.noaa.gov/dataregistry/search/collection/info/coastallidar')
        .attr('target', '_blank');

    noaaLink.append('img')
        .attr('src', 'css/images/noaa@2x.png')
        .attr('title', 'National Oceanic and Atmospheric Administration');

    noaaLink.append('button')
        .attr('class', 'icon-wrapper')
        .append('span')
        .attr('class','icon question-mark');

    noaaLink.append('span')
        .html('Elevation data<br/>courtesy of NOAA');


    var noUSA = L.DomUtil.create('div', 'outside-USA-warning', rightSide);

    d3.select(noUSA).append('img')
        .attr('src', 'css/images/warning@2x.png')
        .attr('title', 'Outside of the United States of America');

    if (this._map.options.noaa2017) {
      d3.select(noUSA).append('span')
          .text('Sea level rise data not available');
    } else {
      d3.select(noUSA).append('span')
          .text('This map may understate risk');
    }

    d3.select(noUSA).append('button')
        .attr('class', 'icon-wrapper')
        .attr('data-abouttarget', 'globalwarning')
        .append('span')
        .attr('class','icon question-mark');


    var ccLogo = L.DomUtil.create('a', 'climate-central-logo', rightSide);
    d3.select(ccLogo)
        .attr('href', 'https://www.climatecentral.org/')
        .append('img')
        .attr('src', 'css/images/logo-climate-central-footer-white.png')
        .attr('alt', 'Climate Central')

    var showText = L.DomUtil.create('h4', 'show-text label', buttonColumn);
    d3.select(showText).text('SHOW:');

    this.buttonColumn = d3.select(buttonColumn);

    this.on('change', this.toggleContentFromNodes, this);

    Surging.Util.preventMouseEvents(container);

    this._map.on('boundschange', this._boundsChange, this);

    return container;
  },

  remove: function(map) {
    this._map.off('bounds-change', this._boundsChange, this);
    this.off('change', this.toggleContentFromNodes, this);
    this._map = null;

    L.Control.prototype.remove.call(this);
  },

  _boundsChange: function(evt) {
    this.container.classed('outside-usa', !evt.status);


    if (evt.status) { // inside USA

    } else { // outside USA

      var closeContent = false;
      this.buttons.forEach(function(b){
        if (b.gauges) return;
        if (b._selected) {
          closeContent = true;
          b.toggleSelected(true);
        }
      });

      if (closeContent) this.toggleContent(false);
    }
  },

  openSecondaryMenu: function() {
    var body = d3.select('body');
    body.on('click.more', this.closeSecondaryMenu);
    body.classed('nav-panel-open map-data-options', true);
  },

  closeSecondaryMenu: function() {
    var body = d3.select('body');
    body.classed('nav-panel-open map-data-options', false);
    body.on('click.more', null);
  },

  setSecondaryMenu: function() {
    var moreBtn = L.DomUtil.create('span', 'more-btn data-toggle surging-control', this.buttonColumn.node());
    d3.select(moreBtn).append('h4').attr('class', 'label').text('More...');

    var that = this,
        body = d3.select('body');

    $(moreBtn).on('click touchstart', function(e){
      e.stopPropagation();
      e.preventDefault();

      var active = body.classed('map-data-options');

      if (!active) {
        that.openSecondaryMenu();
      } else {
        that.closeSecondaryMenu();
      }


    });


    var secondaryMenu = L.DomUtil.create('div', 'secondary-button-menu', moreBtn);
    this.moreMenu = d3.select( L.DomUtil.create('div', 'more-menu', secondaryMenu) );

    var that = this;
    var opts = this.buttons.map(function(btn){
      var label =  btn.options.altLabel || btn.options.label;
      return {
        label: btn.options.altLabel || btn.options.label,
        idx: btn.options.idx,
        sort: btn.options.sortingIndex || 0
      }
    });

    opts.sort(function(a,b){
      return a.sort - b.sort;
    });

    opts.forEach(function(o){
      that.moreMenu
          .append('button')
          .attr('class', 'type-small nav-btn')
          .attr('data-idx', o.idx)
          .text(o.label)
    });

  },

  toggleButtonColumn: function(e) {
    L.DomEvent.stop(e);

    if (this.globalRestricted) return;
    var state = this.container.select('.projections-content').classed('selected');
    this.container.select('.projections-content').classed('selected', !state);
    this.toggleContent(!state);
  },

  toggleContent: function(selected) {
    d3.select('body').classed('data-layer-on', selected);
    this.content.classed('selected', selected);
  },

  toggleContentFromNodes: function() {
    var r = this.content.selectAll('.content')
        .filter(function(){
          return d3.select(this).classed('selected');
        });

    this.toggleContent(r[0].length);

    if (r[0].length) this.container.classed('open', true);
  },

  insertButton: function(btn) {
    btn.addTo(this._map);
    this.buttons.push(btn);

    var that = this;

    btn.on('change', function(e){
      var sel = this._selected;
      var toggle = true;
      if (this.isToggleBtn)  {
        that.buttons.forEach(function(b){
          if (b === e.target) return;
          if (b._selected) {
            b.toggleSelected(true);
          }
        })
      } else {
        if (sel) {
          that.buttons.forEach(function(b){
            if (b.isToggleBtn && b._selected) {
              b.toggleSelected(true);
            }
          });
        }
      }

      that.toggleContent(sel);
      that._map._hash.onMapMove();
    });


  },

  buttonsCount: function() {
    return this.buttons.length;
  },

  selectButton: function(idx) {
    var sel = false;
    this.buttons.forEach(function(b){
      if(b.options.idx === idx) {
        sel = true;
        if (b._selected) return;
        b.toggleSelected(true);
      } else {
        if (b._selected) b.toggleSelected(true);
      }

    });

    this.toggleContent(sel);
    this._map._hash.onMapMove();
  }

});

Surging.Control = L.Control.extend({
  addTo: function(map) {
    L.Control.prototype.addTo.call(this, map);
    var appendContainer = this.options.appendTo ? d3.select(this.options.appendTo).node() : this._container.parentNode;
    appendContainer.appendChild(this._container);
    return this;
  }
});

Surging.Control.MiniHeader = Surging.Control.extend({
  includes: L.Evented,

  options: {
    position: "topleft",
    title: '<img src="css/images/surging-seas.png" alt="Surging Seas">',
    subtitle: [
      'Sea level rise analysis by ',
      '<a href="http://climatecentral.org">',
      '<img src="css/images/climate-central.png">',
      '</a>'
    ].join(""),
    searchLabel: "SUBMERGENCE RISK MAP",
    searchPlaceholder: "Type any place (city, etc.)",
    submitText: '<img src="css/images/search-submit.png" alt="GO">',
    search: {},
    searchService: null,
    focus: true
  },

  initialize: function() {
    Surging.Control.prototype.initialize.apply(this, arguments);
    this._searchService = this.options.searchService
        || new Surging.SearchService(this.options.search);
  },

  addTo: function(map) {
    Surging.Control.prototype.addTo.call(this, map);
    this._container.parentNode.insertBefore(this._container, this._container.parentNode.firstChild);
  },

  onAdd: function(map) {
    var control = this,
        container = this._container = L.DomUtil.create("div", "mini-header surging-control");
    this._map = map;

    var wrapper = d3.select(container)
        .append("div")
        .attr("class", "wrapper");

    var header = wrapper.append("div")
        .attr("class", "header");

    if (this.options.title) {
      header.append("h1")
          .attr("class", "title")
          .append("span")
          .html(this.options.title);
    }

    if (this.options.subtitle) {
      header.append("h2")
          .attr("class", "subtitle")
          .html(this.options.subtitle);
    }

    var form = wrapper.append("form")
            .attr("class", "search")
            .attr("target", "#")
            .on("submit", submit),
        row = form.append("div"),
        label = row.append("label")
            .text(this.options.searchLabel),
        input = label.append("input")
            .attr("class", "query")
            //.attr("autofocus", "autofocus")
            .attr("placeholder", this.options.searchPlaceholder)
            .attr("type", "text"),
        submit = row.append("button")
            .attr("class", "submit")
            .on("click", submit)
            .html(this.options.submitText);

    var error = form.append("div")
        .attr("class", "search-error")
        .style("display", "none");

    error.append("a")
        .attr("class", "close")
        .html("&times;")
        .on("click", function() {
          d3.select(this.parentNode)
              .style("display", "none");

          input.property("value", "")
              .call(_focus);
        });

    error.append("div")
        .attr("class", "error-text");

    if (this.options.focus) {
      input.call(_focus);
    }

    function submit() {
      d3.event.preventDefault();
      var query = input.property("value");
      if (query) {
        if (typeof ga !== 'undefined') {
          ga('send', 'event', Surging.campaign, 'Query: ' + query);
          ga(Surging.campaign + '.send', 'event', 'search-query', 'submit', query);
        }
        control.search(query);
      }
    }

    Surging.Util.preventMouseEvents(container);

    return container;
  },

  search: function(query) {
    if (this._request) this._request.abort();
    var that = this,
        form = d3.select(this._container)
            .select("form")
            .classed("searching", true)
            .classed("error", false)
            .classed("success", false);
    return this._request = this._searchService.search(query, function(error, locations) {
      form.classed("searching", false);

      if (error) {
        form.classed("error", true);
        return that._showError(error);
      } else if (!locations.length) {
        form.classed("error", true);
        return that._showError("No matching locations found.");
      }
      form.classed("success", true);
      that._showLocations(locations);
      that._hideError();
    });
  },

  _showError: function(error) {
    d3.select(this._container)
        .select(".search-error")
        .style("display", null)
        .select(".error-text")
        .html(error || "Unknown error");
  },

  _hideError: function(error) {
    d3.select(this._container)
        .select(".search-error")
        .style("display", "none")
        .select(".error-text")
        .text("");
  },

  _showLocations: function(locations) {
    var first = locations[0];
    d3.select(this._container)
        .select("input.query")
        .property("value", first.name)
        .call(_focus, true);

    var center = [first.latitude, first.longitude];
    if (first.zoom) {
      this._map.setView(center, first.zoom);
    } else {
      this._map.setCenter(center);
    }
  },

  onRemove: function(map) {
    d3.select(this._container)
        .text("");
    this._map = this._container = null;
  },

});

function _focus(selection, select) {
  selection.each(function() {
    this.focus();
    if (select) {
      try { this.select(); } catch (err) { }
    }
  });
}

Surging.Control.SearchOnly = L.Class.extend({
  includes: L.Evented,

  options: {
    selector:null,
    searchPlaceholder: "Type any place (city, etc.)",
    submitText: '<img src="css/images/search-submit.png" alt="GO">',
    search: {},
    searchService: null,
    expandable: false,
    focus: false,
    linkedMaps: null
  },
  currentValue: null,

  initialize: function(map, options) {
    L.Util.setOptions(this, options);
    this._searchService = this.options.searchService
        || new Surging.SearchService(this.options.search);

    this._map = map;
    this.initialState = true;

    var control = this,
        container = this._container = d3.select(this.options.selector);

    var form = container.select('form'),
        input = this._input = container.select('.query'),
        submitBtn = container.select('.submit'),
        errorContainer = container.select('.search-error');

    errorContainer
        .on('click', closeError)
        .select('.close')
        .on("click", closeError);

    form.on('submit', submit);
    submitBtn.on("click", submit);

    if (this.options.focus) {
      input.call(_focus);
    }

    if (this.options.expandable) {
      container.on('click', handleContainerClick);
      container.on('touchstart', handleContainerClick);
      input.on('click', function(){ d3.event.stopPropagation(); });
      input.on('touchstart', function(){ d3.event.stopPropagation(); });
    }

    function handleContainerClick() {
      var stopEvt = true;


      input.node().value = $.trim(input.node().value);
      var w = container.node().offsetWidth;

      if (w < 50 && container.classed('temp-open')) {
        control.toggleSearch(true);
      } else if (!container.classed('open') && !container.classed('temp-open')) {
        control.toggleSearch(true);
      } else if(control.currentValue === input.node().value) {
        control.toggleSearch(false);
      } else if ( (container.classed('open') || container.classed('temp-open')) && /^\s*$/.test( input.node().value)) {
        control.toggleSearch(false);
      } else {
        stopEvt = false;
      }

      if (stopEvt) {
        d3.event.stopPropagation();
        d3.event.preventDefault();
      }
    }

    function closeError() {
      d3.event.stopPropagation();
      d3.event.preventDefault();
      form.classed("error", false);
      input.property("value", "")
          .call(_focus);
    }

    function submit() {
      d3.event.stopPropagation();
      d3.event.preventDefault();

      var query = input.property("value");

      if (query && query.length && control.currentValue !== query) {
        if (query === control.currentValue) return false;
        var googleResults = document.getElementsByClassName('pac-container')[0];
        if (googleResults.length === 0 || googleResults.children.length === 0) {
          control.search.call(control, query);
          if (typeof ga !== 'undefined') {
            ga('send', 'event', Surging.campaign, 'Query: ' + query);
            ga(Surging.campaign + '.send', 'event', 'search-query', 'submit', query);
          }
        }
      } else if (container.classed('open')) {
        control.toggleSearch(false);
      } else {
        return false;
      }
    }

    Surging.Util.preventMouseEvents(container.node());
  },

  registerGoogle: function() {
    var searchInput = document.getElementById("search-box");
    (function pacSelectFirst(input, self) {
      // store the original event binding function
      var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

      function addEventListenerWrapper(type, listener) {
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.
        if (type == "keydown") {
          var orig_listener = listener;
          listener = function(event) {
            var suggestion_selected = $(".pac-item-selected").length > 0;
            if (event.which == 13 && !suggestion_selected) {
              var simulated_downarrow = $.Event("keydown", {
                keyCode: 40,
                which: 40
              });
              orig_listener.apply(input, [simulated_downarrow]);
            }

            orig_listener.apply(input, [event]);
          };
        }

        _addEventListener.apply(input, [type, listener]);
      }

      input.addEventListener = addEventListenerWrapper;
      input.attachEvent = addEventListenerWrapper;

      self._autocomplete = new google.maps.places.Autocomplete(input);
      self._autocomplete.addListener('place_changed', self.onPlaceChanged);

    })(searchInput, this);

    this._autocomplete.component = this;
  },

  onPlaceChanged: function() {
    try {
      var place = this.getPlace();
    } catch (err) {
      console.log("Error getting place from google");
      console.log(err);
      return;
    }
    if (place.geometry) {
      if (typeof ga !== 'undefined') {
        ga('send', 'event', Surging.campaign, 'Query: ' + place.formatted_address);
        ga(Surging.campaign + '.send', 'event', 'search-query', 'submit', place.formatted_address);
      }
      var zoom = undefined;
      if (place.types.indexOf("street_address") !== -1) {
        zoom = 16;
      }
      if (place.types.indexOf("postal_code") !== -1) {
        zoom = 14;
      }
      this.component._showLocations([{
        name: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        zoom: zoom
      }]);
    }
  },


  bodyClick: function() {
    this.toggleSearch(false);
  },

  toggleSearch: function(state) {
    var that = this;
    this._container.classed('open', state);

    if (this.initialState) {
      this._container.classed('temp-open', false);
      this.initialState = false;
    }

    if (state) {
      // don't focus on mobile
      if( !Surging.Util.mobilecheck() ) {
        // this._input.call(_focus);
      }

      this._input.node().focus();
      this._input.node().setSelectionRange(0,0);

    } else {
      try {
        Surging.Util.hideKeyboard();
      } catch(e) {
        console.warn("Error on hide keyboard...");
      }
      this._input.node().blur();
    }
  },

  clear: function() {
    this._input.property("value", "")
  },

  search: function(query) {
    if (this._request) this._request.abort();
    var that = this,
        form = this._container
            .select("form")
            .classed("searching", true)
            .classed("error", false)
            .classed("success", false);

    return this._request = this._searchService.search(query, function(error, response) {
      if (!error) {
        var name = response.features[0].properties.name;
        var region = response.features[0].properties.region;
        var country_a = response.features[0].properties.country_a;
        var country = response.features[0].properties.country;
        var placename;
        if (country_a === "USA") {
          placename = name + ", " + region;
        } else {
          placename = name + ", " + country;
        }
        var locations = [{
          name: placename,
          latitude: response.features[0].geometry.coordinates[1],
          longitude: response.features[0].geometry.coordinates[0]
        }];
      }

      form.classed("searching", false);

      if (error) {
        form.classed("error", true);
        that.fire('searchError');
        console.error(error);
        return that._showError(null);
      } else if (!locations.length) {
        form.classed("error", true);
        that.fire('searchError');
        return that._showError("Error: No locations found");
      }

      if (that.options.expandable) {
        that.toggleSearch(false);
      }

      form.classed("success", true);
      that._showLocations(locations);
      that._hideError();
      that.fire('searchSuccess');
    });
  },

  _showError: function(error) {
    this._container
        .select("form")
        .classed("error", true)
        .select(".error-text")
        .html(error || 'Error: Unknown');
  },

  _hideError: function(error) {
    this._container
        .select("form")
        .classed("error", false)
        .select(".error-text")
        .text("");
  },

  _showLocations: function(locations) {
    var first = locations[0];

    this.currentValue = first.name;

    this._container
        .select("input.query")
        .property("value", first.name)
        .call(_focus, true);

    var center = [first.latitude, first.longitude];
    var zoom = (first.zoom) ? first.zoom : this._getCurrentZoom();
    this._setView(center, zoom, {animate: false});
  },

  _getCurrentZoom: function() {
    if ($.isArray(this._map)) return this._map[0].getZoom();
    return this._map.getZoom();
  },

  _setView: function(center, zoom) {
    if ($.isArray(this._map)) {
      this._map.forEach(function(m){
        m.setView(center, zoom, {animate: false});
      });
    } else {
      this._map.setView(center, zoom, {animate: false});
    }
  },

  onRemove: function(map) {
    if ($.isArray(this._map)) {
      this._map.forEach(function(m){
        m = null;
      });
    }

    this._map = this._container = null;
  }

});

Surging.Control.ToggleButton = Surging.Control.extend({
  includes: L.Evented,

  options: {
    idx: null,
    layer: "",
    label: "",
    position: "bottomleft",
    showText: "Show",
    hideText: "Hide",
    selected: false,
    appendTo: null,
    contentContainer: null,
    contentKlass: "",
    additionalKlasses: "",
    closeAndInfo: true,
    aboutTarget: null
  },

  onAdd: function(map) {
    var control = this;

    this._map = map;
    var container = this._container = L.DomUtil.create("div", "data-toggle surging-control");

    var div = d3.select(container)
        .classed("ui-button", true)
        .datum(this.options)
        .on("click", function() {
          control.toggleSelected();
          // Uncomment to hide tidegauge markers by default. Also must set default in css.
//          if (d3.select(this).select(".label").text() === "See projections") {
//            if (d3.select(this).classed("selected")) {
//              d3.selectAll(".tidegauge-marker").style("display", "block");
//            } else {
//              d3.selectAll(".tidegauge-marker").style("display", "none");
//            }
//          } else {
//            d3.selectAll(".tidegauge-marker").style("display", "none");
//          }
        });

    div.append("a")
        .attr("class", "show unselected")
        .text(this.options.showText);

    div.append("a")
        .attr("class", "hide selected")
        .text(this.options.hideText);


    div.append("h4")
        .attr("class", "label")
        .html(this.options.label || "");


    var contentContainer = this._contentContainer = (this.options.contentContainer) ? d3.select(this.options.contentContainer) : div;

    var contentWrapper = this._contentWrapper = contentContainer.append("div")
        .attr("class", "content selected " + this.options.contentKlass + " " + this.options.additionalKlasses)
        .html(this.options.content || "");

    if (this.options.closeAndInfo) {
      var closeSection = contentWrapper
          .append("div")
          .attr("class", "close-info");

      var infoBtn = closeSection.append('button')
          .attr('class', 'icon-wrapper');

      infoBtn.append('span')
          .attr('class','icon question-mark');

      if (this.options.aboutTarget) infoBtn.attr('data-abouttarget', this.options.aboutTarget);

      closeSection.append('button')
          .attr('class', 'simple-close-btn')
          .text('×');

      $(contentWrapper.node()).find('.simple-close-btn').on('touchstart click', function(evt){
        L.DomEvent.stop(evt);
        control.toggleSelected();
      });
    }

    var toggle = this._toggleBtn = contentWrapper
        .append('button')
        .attr('class', 'toggle-panel')
        .text('hide');

    toggle.on('click', function(){
      d3.event.preventDefault();
      var st = contentWrapper.classed('hide-panel');
      control.togglePanel(!st);

    });


    Surging.Util.preventMouseEvents(container);

    // on add, don't try to update hash state
    this.setSelected(this.options.selected, true);

    return this._container;
  },

  togglePanel: function(hide) {
    var txt = hide ? 'show' : 'hide';
    this._toggleBtn.text(txt);
    this._contentWrapper.classed('hide-panel', hide);
  },

  show: function(silent) {
    return this.setSelected(true, silent);
  },

  hide: function(silent) {
    return this.setSelected(false, silent);
  },

  toggleSelected: function(silent) {
    if (!this._selected) {
      this.togglePanel(false);
    }
    return this.setSelected(!this._selected, silent);
  },

  getSelected: function() {
    return this._selected;
  },

  setSelected: function(selected, silent) {
    this._selected = selected;

    d3.select(this._container)
        .classed("selected", this._selected)
        .classed("unselected", !this._selected);


    if (this.options.contentContainer) {
      var that = this;
      d3.select(this.options.contentContainer + " ." + this.options.contentKlass)
          .classed('selected', this._selected);
    }

    if (typeof ga !== 'undefined' && this._selected) {
      var action = (this.options.gaq) ? this.options.gaq : this.options.label + ' Toggle';
      ga('send', 'event', Surging.campaign, action);
      ga(Surging.campaign + '.send', 'event', 'data-layer', 'configure', this.options.label);
    }

    if (!silent) {
      this.fireEvent("change", selected);
    }

    return this;
  },

  onRemove: function() {
    d3.select(this._container).text("");
    this._container = null;
  }
});

Surging.Control.LegendControl = Surging.Control.ToggleButton.extend({
  isToggleBtn: true,
  options: {
    label: 'Legend',
    content: [
      '<table class="legend-key auto">',
      '<tr><td><img src="img/legend/level.png?v=2"/><span>Below water level</span></td>',
      '<td><img src="img/legend/isolated.png?v=2"/><span>Below but isolated</span></td></tr>',
      '<tr><td><img src="img/legend/levees.png?v=2"/><span>Levee</span></td>',
      '<td><img src="img/legend/gauges.png?v=2"/><span>Tide gauges</span></td>',
      '</tr>',
      '</table>'
    ].join(""),
    appendTo: null,
    contentContainer: null,
    contentKlass: "features-content",
  },

  setSelected: function(selected,silent) {
    return Surging.Control.ToggleButton.prototype.setSelected.apply(this, arguments);
  },
  onAdd: function(map) {
    this._map = map;
    return Surging.Control.ToggleButton.prototype.onAdd.call(this, map);
  }
});


Surging.Control.LandmarksControl = Surging.Control.ToggleButton.extend({
  isToggleBtn: true,
  options: {
    label: "Landmarks",
    position: "bottomright",
    content: "",
    layerUrl: "poi",
    minZoomNeeded: 13,
    embedLabel: "Embed This Map",
    aboutLabel: "About & Terms",
    appendTo: null,
    contentContainer: null,
    contentKlass: "features-content",

    poiIcons: [
      [{
        image: "css/images/icon-hospital-20x20.png",
        alt: "Hospital",
        text: "Hospital"
      },
        {
          image: "css/images/icon-fire-20x20.png",
          alt: "Fire/EMS/police",
          text: "Fire/EMS/police"
        },
        {
          image: "css/images/icon-school-20x20.png",
          alt: "School/college",
          text: "School/college"
        },
        {
          image: "css/images/icon-worship-20x20-by-carson-wittenberg.png",
          alt: "House of worship. Prayer icon by Carson Wittenberg from the Noun Project",
          text: "House of worship"
        }],

      [{
        image: "css/images/icon-culture-20x20.png",
        alt: "Culture/museums/arts",
        text: "Culture/museums/arts"
      },
        {
          image: "css/images/icon-government-20x20.png",
          alt: "Government/community",
          text: "Government/community"
        },
        {
          image: "css/images/icon-powerplant-20x20.png",
          alt: "Powerplants",
          text: "Powerplant"
        },
        {
          image: "css/images/icon-military-20x20.png",
          alt: "Military area",
          text: "Military area"
        }]
    ]
  },

  onAdd: function(map) {
    this.layer = new Surging.TileLayer(this.options.layerUrl);
    this._map = map;
    this.options.selected = (this._map.poisState && this._map.poisState == "show");

    var container = Surging.Control.ToggleButton.prototype.onAdd.call(this, map);

    var contentWrapper = this._contentContainer
        .select('.' + this.options.contentKlass);

    var table = contentWrapper
        .append("table")
        .classed("poi-key", this.options.poiIcons);

    var tr = table.selectAll("tr")
        .data(this.options.poiIcons)
        .enter()
        .append("tr");

    var td = tr.selectAll('td')
        .data(function(row){
          return row.map(function(d){
            return d;
          });
        });

    var cell = td.enter().append('td');

    cell.append("img")
        .attr("src", function(d) { return d.image; })
        .attr("alt", function(d) { return d.alt; });

    cell.append('span')
        .text(function(d) { return d.text; });

    if (this._map.poisState && this._map.poisState == "show") {
      this.layer.addTo(this._map);
    }

    return container;
  },

  showEmbed: function() {
    d3.select("#theembedpage").classed("showing", true);
    d3.select("#modal-mask").classed("hidden",false);
    d3.select("#theembedpage .content").node().scrollTop = 0;
    Surging.Embed.Show();
  },

  showAbout: function() {
    d3.select("#theaboutpage").classed("showing", true);
    d3.select("#modal-mask").classed("hidden",false);
    d3.select("#theaboutpage .content").node().scrollTop = 0;
  },

  hideModal: function() {
    d3.select("#theembedpage").classed("showing",false);
    d3.select("#theaboutpage").classed("showing",false);
    d3.select("#waterlevelhelppage").classed("showing",false);
    d3.select("#modal-mask").classed("hidden",true);
    Surging.Embed.Hide();
  },

  // POIs

  setSelected: function(selected, silent) {
    if (selected && !this.layer._map) {
      this.layer.addTo(this._map);
      this._map.poisState = "show";

      /* Check to make sure we at the necessary zoom level to see features */
      var z = this._map.getZoom();
      if (z < this.options.minZoomNeeded) {
        this._map.setView(this._map.getCenter(), this.options.minZoomNeeded);
      }

    } else if (!selected && this.layer._map) {
      this._map.removeLayer(this.layer);
      this._map.poisState = "hide";
    }

    if (!silent) {
      this._map._hash.onMapMove();
    }

    return Surging.Control.ToggleButton.prototype.setSelected.apply(this, arguments);
  },

  onRemove: function(map) {
    if (this.layer && this.layer._map === map) {
      map.removeLayer(this.layer);
    }
    this.layer = null;

    d3.select(this._map._container)
        .selectAll(".about")
        .remove();

    return Surging.Control.ToggleButton.prototype.onRemove.apply(this, arguments);
  }
});

Surging.Control.MapStackButton = Surging.Control.ToggleButton.extend({
  options: {
    position: "bottomleft",
    label: "",
    // the stack (an id or array) to show when toggled
    onStack: null,
    // default to the stack that's showing when the control is added
    offStack: "satellite",
    content: "",
    riskLinks: null
  },

  onAdd: function(map) {
    this.options.bob = false;
    this._onStack = this.options.onStack;
    this._offStack = this.options.offStack || map.getStack();

    map.on("stackchange", this._onStackChange, this);
    map.on("moveend", this._onMapChange, this)

    var initStack = Surging.Stack.getId(map.getStack());
    if (initStack == this._onStack) {
      this.options.selected = true;
      this._getLinks(true);
    }

    return Surging.Control.ToggleButton.prototype.onAdd.call(this, map);
  },

  onRemove: function(map) {
    map.off("stackchange", this._onStackChange);
    map.on("moveend", this._onMapChange);
    return Surging.Control.ToggleButton.prototype.onRemove.call(this, map);
  },

  _onMapChange: function() {
    if (!this._selected) return;
    this._getLinks(true);
  },

  _getLinks: function(selected) {
    if (!selected) return;
    if (!this.options.riskLinks || !this.options.riskLinks.updater) return;
    if (this._gettingLinks) return;

    var bounds = this._map.getBounds(),
        nw = bounds.getNorthWest(),
        se = bounds.getSouthEast(),
        extent = [nw.lat, se.lng, se.lat, nw.lng].join(",");
    this._gettingLinks = true;
    this.options.riskLinks.updater(extent, L.Util.bind(this._setLinks, this));
  },

  _setLinks: async function(error, links) {
    this._gettingLinks = false;
    if (!this.options.riskLinks || !this.options.riskLinks.updater) return;
    var page = 'compare'; //this.options.page;

    var compareContainer = this._contentContainer.select('.compare-links');
    compareContainer.html('');

    if (error) {
      return;
    }

    if(page == "compare")
    {

      var gotState = false;
      var gotCounty = false;
      var stateInfo;
      var countyInfo;
      var stateContainer;
      var countyContainer;
      var linkContainer;

      var compareContainer = this._contentContainer.select('.' + this.options.contentKlass).select('.compare-links');
      compareContainer.html('');

      var categories = {
        Population: "Population",
        Population_highSV: "Socially vulnerable",
        Property: "Property",
        Roads: "Roads",
        Schools: "Schools",
        Hospitals: "Hospitals"
      };
      for(var i = 0; i < links.length; i++)
      {
        if(links[i].type == "state" && !gotState)
        {
          gotState = true;
          stateInfo = links[i];
          ssrf2stateID = stateInfo.label.toLowerCase().replace(" ", "-") + ".us";
        }
        if(links[i].type == "county" && !gotCounty)
        {
          gotCounty = true;
          countyInfo = links[i];
        }
      }

      if (gotState || gotCounty) {
        linkContainer = compareContainer.append('ul');
        linkContainer.append('li')
            .attr('class', 'title')
            .text(this.options.riskLinks.label + ': Compare');

        var queryStr = "&impact=Population_highSV&impactGroup=Population";
        if (this.options.label === "Population") {
          queryStr = "&impact=Population&impactGroup=Population";
        } else if (this.options.label == "Ethnicity") {
          queryStr = "&impact=Population&impactGroup=Population";
        } else if (this.options.label == "Property") {
          queryStr = "&impact=Property&impactGroup=Buildings";
        }
      }

      if(gotState)
      {
        stateContainer = linkContainer.append("li");
        //Pull out the state id from the url
        state = stateInfo.label.replace(" ","+");
        locid = stateInfo.href.split("location=")[1].split("&")[0];
        url = "http://riskfinder.climatecentral.org/state/" + ssrf2stateID + "?comparisonType=county" + queryStr + "#exposure-comparison";
        stateContainer.append('span').attr('class', 'icon external-link');
        stateContainer.append("a").html('Counties in <span class="notranslate">' + stateInfo.label + '</span>').attr("href", url).attr("target","_blank");
      }

      if(gotCounty)
      {
        countyContainer = linkContainer.append('li');
        locid = countyInfo.href.split("location=")[1].split("&")[0];
        let url = "http://riskfinder.climatecentral.org/postal-code?container=" +  ssrf2stateID;
        let label = stateInfo.label;

        const data = await d3.json("http://riskfinder.climatecentral.org/api/metadata/geo/county?container=" + ssrf2stateID);
        let countyID = null;
        for (var k in data) {
          if (data[k].ssid === locid) {
            countyID = k;
            break;
          }
        }
        if (countyID) {
          url = "http://riskfinder.climatecentral.org/county/" + countyID + "?comparisonType=postal-code" + queryStr + "#exposure-comparison";
          label = countyInfo.label;
        }
        countyContainer.append('span').attr('class', 'icon external-link');
        countyContainer.append("a").html('ZIPs in <span class="notranslate">' + label + '</span>').attr("target","_blank");
      }
    }
  },

  toggleSelected: function() {
    var selected = !this._selected;
    this._toggling = true;
    if (selected) {
      this._map.setStack(this._onStack, true);
      if (selected) {
        this._getLinks(true);
      }
    } else {
      // revert landOrSea option
      this._map.setStack(this._offStack, true);
    }
    this._toggling = false;
    return Surging.Control.ToggleButton.prototype.toggleSelected.apply(this, arguments);
  },

  _onStackChange: function(e) {
    if (this._toggling) return;
    var selected = e.stack === this._onStack;
    this.setSelected(selected);
  }
});

Surging.Control.SoviToggle = Surging.Control.MapStackButton.extend({
  options: {
    label: "Social vulnerability",
    // the stack (an id or array) to show when toggled
    onStack: "sovi",
    layer: {
      url: "social_vulnerability",
      zIndex: 4,
      opacity: .1,
    },
    content: [
      '<table class="sovi-key">',
      '<tr>',
      '<td class="low">Low</td>',
      '<td class="medium">Medium</td>',
      '<td class="high">High</td>',
      '</tr>',
      '</table>'
    ].join("")
  },


  onAdd: function(map) {
    if (this.options.layer) {
      this._layer = new Surging.TileLayer(this.options.layer.url, this.options.layer);
    }
    return Surging.Control.MapStackButton.prototype.onAdd.call(this, map);
  },

  setSelected: function(selected) {
    if (this._layer) {
      if (selected && !this._layer._map) {
        this._map.addLayer(this._layer);
        this._layer.setZIndex(this.options.zIndex);
      } else if (!selected && this._layer._map) {
        this._map.removeLayer(this._layer);
      }
    }
    return Surging.Control.MapStackButton.prototype.setSelected.call(this, selected);
  }
});


Surging.Control.popdToggle = Surging.Control.MapStackButton.extend({
  options: {
    label: "Population",
    // the stack (an id or array) to show when toggled
    onStack: "popd",
    layer: {
      url: "population_density",
      zIndex: 4,
      opacity: .1,
    },
    content: [
      '<table class="prop-key">',
      '<tr>',
      '<td class="prop0">Less than 100 people*</td></tr>',
      '<tr><td class="prop1">100-999</td></tr>',
      '<tr><td class="prop2">1000-9,999</td></tr>',
      '<tr><td class="prop3">10,000-99,999</td></tr>',
      '<tr><td class="prop4">More than 100,000</td></tr>',
      '<tr><td>* per square mile</td></tr>',
      '</tr>',
      '</table>'
    ].join("")
  },

  onAdd: function(map) {
    if (this.options.layer) {
      this._layer = new Surging.TileLayer(this.options.layer.url, this.options.layer);
    }
    return Surging.Control.MapStackButton.prototype.onAdd.call(this, map);
  },

  setSelected: function(selected) {
    if (this._layer) {
      if (selected && !this._layer._map) {

        this._map.addLayer(this._layer);
        this._layer.setZIndex(this.options.zIndex);
      } else if (!selected && this._layer._map) {
        this._map.removeLayer(this._layer);
      }
    }
    return Surging.Control.MapStackButton.prototype.setSelected.call(this, selected);
  }
});

Surging.Control.propertyToggle = Surging.Control.MapStackButton.extend({
  options: {
    label: "Property",
    // the stack (an id or array) to show when toggled
    onStack: "property",
    layer: {
      url: "property",
      zIndex: 4,
      opacity: .1,
    },
    content: [
      '<table class="prop-key">',
      '<tr>',
      '<td class="prop0">Less than $100,000*</td></tr>',
      '<tr><td class="prop1">$100,000-$999,999</td></tr>',
      '<tr><td class="prop2">$1 Million-$10 Million</td></tr>',
      '<tr><td class="prop3">$10 Million-$100 Million</td></tr>',
      '<tr><td class="prop4">More than $100 Million</td></tr>',
      '<tr><td>* per acre</td></tr>',
      '</tr>',
      '</table>'
    ].join("")
  },

  onAdd: function(map) {
    if (this.options.layer) {
      this._layer = new Surging.TileLayer(this.options.layer.url, this.options.layer);
    }
    return Surging.Control.MapStackButton.prototype.onAdd.call(this, map);
  },

  setSelected: function(selected) {
    if (this._layer) {
      if (selected && !this._layer._map) {

        this._map.addLayer(this._layer);
        this._layer.setZIndex(this.options.zIndex);
      } else if (!selected && this._layer._map) {
        this._map.removeLayer(this._layer);
      }
    }
    return Surging.Control.MapStackButton.prototype.setSelected.call(this, selected);
  }
});

Surging.Control.incomeToggle = Surging.Control.MapStackButton.extend({
  options: {
    label: "Income",
    // the stack (an id or array) to show when toggled
    onStack: "income",
    layer: {
      url: "income",
      zIndex: 4,
      opacity: .1,
    },
    content: [
      '<table class="prop-key">',
      '<tr><td class="prop0">80-100%</td></tr>',
      '<tr><td class="prop1">60-80%</td></tr>',
      '<tr><td class="prop2">40-60%</td></tr>',
      '<tr><td class="prop3">20-40%</td></tr>',
      '<tr><td class="prop4">0-20%</td></tr>',
      '<tr><td>Percentile</td></tr>',
      '</table>'
    ].join("")
  },

  onAdd: function(map) {
    if (this.options.layer) {
      this._layer = new Surging.TileLayer(this.options.layer.url, this.options.layer);
    }
    return Surging.Control.MapStackButton.prototype.onAdd.call(this, map);
  },

  setSelected: function(selected) {
    if (this._layer) {
      if (selected && !this._layer._map) {

        this._map.addLayer(this._layer);
        this._layer.setZIndex(this.options.zIndex);
      } else if (!selected && this._layer._map) {
        this._map.removeLayer(this._layer);
      }
    }
    return Surging.Control.MapStackButton.prototype.setSelected.call(this, selected);
  }
});

Surging.Control.ethnicityToggle = Surging.Control.MapStackButton.extend({
  options: {
    label: "Ethnicity",
    // the stack (an id or array) to show when toggled
    onStack: "ethnicity",
    layer: {
      url: "ethnicity",
      zIndex: 4,
      opacity: 0.2,
    },
    content: [
      '<table class="eth-key">',
      '<tr>',
      '<td class="eth0">White</td></tr>',
      '<tr><td class="eth1">Asian</td></tr>',
      '<tr><td class="eth2">Hispanic</td></tr>',
      '<tr><td class="eth3">Black</td></tr>',
      '<tr><td class="eth4">Native American</td></tr>',
      '<tr><td>1 dot per person</td></tr>',
      '</tr>',
      '</table>'
    ].join("")
  },

  onAdd: function(map) {
    if (this.options.layer) {
      this._layer = new Surging.TileLayer(this.options.layer.url, this.options.layer);
    }
    return Surging.Control.MapStackButton.prototype.onAdd.call(this, map);
  },

  setSelected: function(selected) {
    if (this._layer) {
      if (selected && !this._layer._map) {

        this._map.addLayer(this._layer);
        this._layer.setZIndex(this.options.zIndex);
      } else if (!selected && this._layer._map) {
        this._map.removeLayer(this._layer);
      }
    }
    return Surging.Control.MapStackButton.prototype.setSelected.call(this, selected);
  }
});

Surging.Control.RiskFinderLinks = Surging.Control.extend({
  includes: L.Evented,

  options: {
    label: "What Could Flood?",
    position: "topright",
    page: "when"
  },

  onAdd: function(map) {
    var control = this;

    this._onMapChange = Surging.Util.debounce(this._onMapChange, 500, this);

    this._map = map;
    this._map.on("zoom", this._onMapChange, this);
    this._map.on("move", this._onMapChange, this);

    var container = this._container = L.DomUtil.create("div", "surging-control risk-finder-links");

    var div = d3.select(container)
        .classed("riskfinder", true)
        .datum(this.options);

    this._buttonContainer = div.append("div").append("table").attr("width","100%").style("margin","0").style("border-spacing","0").append("tr");

    this._whenButton = this._buttonContainer.append("td").append("div").attr("class","selected");
    this._analysisButton = this._buttonContainer.append("td").append("div").attr("class","unselected");
    this._compareButton = this._buttonContainer.append("td").append("div").attr("class","unselected");
    this._reportButton = this._buttonContainer.append("td").append("div").attr("class","unselected");
    var bottomContainer = div.append("div").attr("class","bottom_container").style("padding","10px 10px 0px 10px");

    //var label = bottomContainer.append("h4")
    //  .attr("class", "label")
    //  .text(this.options.label);

    this._linkContainer = bottomContainer.append("p")
        .attr("class", "links").append("span");

    var label = this._linkContainer.append("span").text("See sea level and flood projections over time for: ");

    this._compareButton
        .append("a")
        .attr("href","#")
        .attr("class","buttons")
        .text("COMPARISON")
        .on("click", function(){
          control.options.page = "compare";
          control.options.label = "What Could Flood?";
          label.text("");
          control._compareButton.attr("class","selected");
          control._whenButton.attr("class","unselected");
          control._analysisButton.attr("class","unselected");
          control._reportButton.attr("class","unselected");
          d3.selectAll(".place").remove();
          control._onMapChange();
        });

    this._whenButton
        .append("a")
        .attr("href","#")
        .attr("class","buttons")
        .text("FORECAST")
        .on("click", function(){
          control.options.page = "when";
          control.options.label = "When Could It Flood?";
          label.text("See sea level and flood projections for: ");
          control._compareButton.attr("class","unselected");
          control._whenButton.attr("class","selected");
          control._analysisButton.attr("class","unselected");
          control._reportButton.attr("class","unselected");
          control._onMapChange();
          d3.selectAll(".place").remove();
        });
    this._analysisButton
        .append("a")
        .attr("href","#")
        .attr("class","buttons")
        .text("ANALYSIS")
        .on("click", function(){
          control.options.page = "analysis";
          control.options.label = "Analysis";
          label.text("See detailed exposure analysis for: ");
          control._compareButton.attr("class","unselected");
          control._whenButton.attr("class","unselected");
          control._analysisButton.attr("class","selected");
          control._reportButton.attr("class","unselected");
          control._onMapChange();
          d3.selectAll(".place").remove();
        });
    this._reportButton
        .append("a")
        .attr("href","#")
        .attr("class","buttons")
        .text("FAST LOOK")
        .on("click", function(){
          control.options.page = "report";
          control.options.label = "Fast Look";
          label.text("All-in-one reports for: ");
          control._compareButton.attr("class","unselected");
          control._whenButton.attr("class","unselected");
          control._analysisButton.attr("class","unselected");
          control._reportButton.attr("class","selected");
          control._onMapChange();
          d3.selectAll(".place").remove();
        });
    Surging.Util.preventMouseEvents(container);

    this._onMapChange();

    return this._container;
  },

  onRemove: function() {
    d3.select(this._container).text("");
    this._container = null;
  },

  _onMapChange: function(e) {
    var bounds = this._map.getBounds(),
        nw = bounds.getNorthWest(),
        se = bounds.getSouthEast(),
        extent = [nw.lat, se.lng, se.lat, nw.lng].join(",");
    this.options.getLinks(extent, L.Util.bind(this._setLinks, this));
  },

  _setLinks: async function(error, links) {
    /*
     d3.select(this._container)
     .style("visibility", error ? "hidden" : "visible");
     */
    var page = this.options.page;

    d3.selectAll(".place").remove();
    if(page == "compare")
    {


      var gotState = false;
      var gotCounty = false;
      var stateInfo;
      var countyInfo;
      var stateContainer;
      var countyContainer;



      var compareContainer = this._linkContainer.append("div").attr("class","place");

      var categories = {
        Population: "Population",
        Population_highSV: "Socially vulnerable",
        Property: "Property",
        Roads: "Roads",
        Schools: "Schools",
        Hospitals: "Hospitals"
      };
      for(var i = 0; i < links.length; i++)
      {
        if(links[i].type == "state" && !gotState)
        {
          gotState = true;
          stateInfo = links[i];
          ssrf2stateID = stateInfo.label.toLowerCase().replace(" ", "-") + ".us";
        }
        if(links[i].type == "county" && !gotCounty)
        {
          gotCounty = true;
          countyInfo = links[i];
        }
      }

      var queryStr = "&impact=Population_highSV&impactGroup=Population";
      if (this.options.label === "Population") {
        queryStr = "&impact=Population&impactGroup=Population";
      } else if (this.options.label == "Ethnicity") {
        queryStr = "&impact=Population&impactGroup=Population";
      } else if (this.options.label == "Property") {
        queryStr = "&impact=Property&impactGroup=Buildings";
      }

      if(gotState)
      {
        stateContainer = compareContainer.append("div");
        stateContainer.append("span").text("Compare counties in " + stateInfo.label + " by exposure of: ");
        //Pull out the state id from the url
        state = stateInfo.label.replace(" ","+");
        locid = stateInfo.href.split("location=")[1].split("&")[0];
        url = "http://riskfinder.climatecentral.org/state/" + ssrf2stateID + ".us?comparisonType=county" + queryStr + "#exposure-comparison";
        for(category in categories)
        {
          stateContainer.append("a").text(categories[category]).attr("href", url).attr("target","_blank").style("text-decoration","none");
          stateContainer.append("span").text(", ");
        }
      }
      if(gotCounty)
      {
        locid = countyInfo.href.split("location=")[1].split("&")[0];
        //state = locid.split("_")[0]
        let url = "http://riskfinder.climatecentral.org/postal-code?container=" +  ssrf2stateID;
        let label = stateInfo.label;

        const data = await d3.json("http://riskfinder.climatecentral.org/api/metadata/geo/county?container=" + ssrf2stateID);
        var countyID = null;
        for (var k in data) {
          if (data[k].ssid === locid) {
            countyID = k;
            break;
          }
        }
        if (countyID) {
          url = "http://riskfinder.climatecentral.org/county/" + countyID + "?comparisonType=postal-code" + queryStr + "#exposure-comparison";
          label = countyInfo.label;
        }

        countyContainer = compareContainer.append("div").style("margin-top","3px");
        countyContainer.append("span").text("Compare zips in " + label + ": ");

        for (category in categories) {
          countyContainer.append("a").text(categories[category]).attr("href", url).attr("target","_blank").style("text-decoration","none");
          countyContainer.append("span").text(", ");
        }
      }
    }
    if(page == "analysis" || page == "when" || page == "report")
    {

      var places = this._linkContainer
          .selectAll(".place").data(error ? [] : links || []);
      places.enter().append("span")
          .attr("class", "place")
          .append("a");

      places.data(error ? [] : links || []);


      places.select("a")
          .attr("href", function(d) {

            locid = d.href.split("location=")[1].split("&")[0];
            state = locid.split("_")[0]
            placetype = locid.split("_")[1];
            placeName = d.label.replace(" ","_")
//            d.href += "&State="
            if(page == "analysis")
            {
              return d.href;
            }
            else if(page == "when")
            {
              return d.href.replace("=L","=P");
            }
            else
            {
              if(placetype == "State")
              {
                return "http://ssrf.climatecentral.org.s3-website-us-east-1.amazonaws.com/Buffer2/states/" + state + "/downloads/pdf_reports/" + placetype + "/" + state + "_State-report.pdf";
              }
              else
              {
                return "http://ssrf.climatecentral.org.s3-website-us-east-1.amazonaws.com/Buffer2/states/" + state + "/downloads/pdf_reports/" + placetype + "/" + state + "_" + placeName + "-report.pdf";
              }
            }
          })
          .attr("target","_blank").style("text-decoration","none")
          .html(function(d) { return d.label; });
    }
  }
});


Surging.Control.RiskFinderUpdater = L.Class.extend({
  options: {
    apiUrl: "//ssws.climatecentral.org/places-by-extent",
    hrefBaseUrl: "",
    query: {
      limit: 5
    }
  },

  initialize: function(options) {
    L.Util.setOptions(this, options);
  },

  update: async function(extent, callback) {
    if (this.request) this.request.abort();
    const query = L.extend({}, this.options.query, {extent});
    const url = this.options.apiUrl + Surging.Util.QueryString.format(query);
    const hrefBaseUrl = this.options.hrefBaseUrl;
    // const that = this;
    // this.request = d3.json(url, function(error, data) {
    //   var places = !error && data
    //       ? (data.places || []).map(function(place) {
    //     place.href = hrefBaseUrl + place.href;
    //     return place;
    //   })
    //       : null;
    //   callback.call(that, error, places);
    // });

    const data = await d3.json(url);
    const places = data ? (data.places || []).map((place) => {
      place.href = hrefBaseUrl + place.href;
      return place;
    }) : null;
    this.request = callback.call(this, null, places);
  },

  getUpdate: function() {
    return L.Util.bind(this.update, this);
  }
});

Surging.Control.WaterLevelHelpButton = Surging.Control.extend({
  options: {
    position: "bottomleft"
  },

  onAdd: function() {
    container = this._container = L.DomUtil.create("div", "water-level-help-button");
    d3.select(this._container).on("click", function() {
      Surging.Util.preventMouseEvents(container);
      d3.select("#waterlevelhelppage").classed("showing", true);
      d3.select("#modal-mask").classed("hidden",false);
    });
    return this._container;
  }
});

Surging.TideGauges = Surging.Control.ToggleButton.extend({
  isToggleBtn: true,

  gauges:null,
  markers: [],
  _map:null,
  _inView: 0,
  popup: null,
  markerBackgroundKlass:'',

  lookups: {
    'RCP26': 'extreme carbon cuts',
    'RCP45': 'moderate carbon cuts',
    'RCP85': 'unchecked pollution'
  },

  options: {
    settings: {
      statistic: 'SLR',
      emissions: 'RCP85',
      waterlevel: 5,
      unit: 'ft',
      riskkey: 'accrued:20',
      eventkey: 'slr'
    },
    errors: {
      icon: 'N/A',
      callout: 'is not yet available here.'
    },
    source: "",
    layer: "",
    label: "See projections",
    position: "bottomleft",
    showText: "Show",
    hideText: "Hide",
    selected: false,
    appendTo: null,
    contentContainer: null,
    contentKlass: "projections-content",
    content: [
      '<form class="loading">',
      '<div class="loading-msg"><p>Loading tide gauge data...</p></div>',
      '<table>',
      '<tr><td>',
      '<div class="projections-dd-wrapper">',
      '<label for="projections-dd-scenario" class="settings-label">Scenario:</label>',
      '<div id="projections-dd-scenario" class="wrapper-dropdown top hamburger nowrap autosize">',
      '<span class="dropdown-label">&nbsp;</span>',
      '<ul class="dropdown">',
      '<li data-value="RCP26" class="extreme">Extreme carbon cuts</li>',
      '<li data-value="RCP45" class="moderate">Moderate carbon cuts</li>',
      '<li data-value="RCP85" class="unchecked">Unchecked pollution</li>',
      '</ul>',
      '</div>',
      '</div>',
      '</div>',
      '<div class="projections-dd-wrapper">',
      '<label for="projections-dd-event" class="settings-label">Event:</label>',
      '<div id="projections-dd-event" class="wrapper-dropdown top hamburger nowrap autosize">',
      '<span class="dropdown-label">&nbsp;</span>',
      '<ul class="dropdown">',
      '<li data-value="slr" class="slr alt-color" data-hoistclass="alt-color">Sea level rise</li>',
      '<li data-value="flood" class="flood">Flood</li>',
      '</ul>',
      '</div>',
      '</div>',
      '</div>',

      '<div id="projection-risk" class="projections-dd-wrapper">',
      '<label for="projections-dd-risk" class="settings-label">Risk:</label>',
      '<div id="projections-dd-risk" class="wrapper-dropdown top hamburger nowrap autosize">',
      '<span class="dropdown-label">&nbsp;</span>',
      '<ul class="dropdown">',
      '<li data-value="accrued:10" class="extreme">10% accrued</li>',
      '<li data-value="annual:10" class="extreme-light">10% annual</li>',
      '<li data-value="accrued:20" class="moderate">20% accrued</li>',
      '<li data-value="annual:20" class="moderate-dark">20% annual</li>',
      '<li data-value="accrued:50" class="unchecked">50% accrued</li>',
      '<li data-value="annual:50" class="unchecked-dark">50% annual</li>',
      '</ul>',
      '</div>',
      '</div>',
      '</div>',
      '</td>',
      '<td class="meta-legend">',
      '<div><img src="img/tidegauge-white.png"/><p id="projections-ui-legend"></p></div>',
      '</td></tr>',
      '</table>',
      '</form>'].join('')
  },

  load: function() {
    var that = this;

    d3.tsv(this.options.source, function(err, rsp){
      if (err) return console.warn(err);

      var gauges = {};
      rsp.forEach(function(g) {
        gauges[g['Station']] = g;
      });
      that.gauges = gauges;

      // Temporary: no observations available for these gauges; ignore them.
      delete that.gauges[8656483];
      delete that.gauges[8635750];
      that.createMarkers();
      that.show();
      that._contentContainer.select('.loading').classed('loading', false);
    });

    return this._container;
  },

  setSelected: function(selected, silent) {

    if (selected) {
      if (this._inView < 1) this.findNearest();
    } else {
      this._onPopupClose();
      if (this.popup) this._map.removeLayer(this.popup);
    }

    this._updateMapWithState(selected);
    d3.select('body').classed('projections-on', selected);

    return Surging.Control.ToggleButton.prototype.setSelected.apply(this, arguments);
  },

  onAdd: function(map) {
    var that = this;
    this._map = map;

    this._loadStateFromMap();

    this.popup = new Surging.TideGauges.Popup({
      offset: [170, -10],
      className: 'projections-popup'
    });

    this.load();

    this.popup.on('close', this._onPopupClose, this);
    map.on('waterlevel', this._onWaterLevelChange, this);
    map.on('waterunit', this._onWaterUnitChange, this);

    this._onWaterLevelChange(null, true);
    this._onWaterUnitChange(null, true);

    map.on('moveend', this._onMapMoveEnd, this);

    Surging.Control.ToggleButton.prototype.onAdd.call(this, map);

    this.setDropdowns();

    return this._container;
  },

  _loadStateFromMap: function() {
    var state = this._map.getProjectionsState();
    if(!state) {
      this.options.selected = false;
    } else {
      var parts = state.split('-');

      this.options.selected = (parts[0] == '1') ? true : false;
      this.options.settings.emissions = (parts[1] in this.lookups) ? parts[1] : this.options.settings.emissions;

      if (parts[2] && (parts[2].toLowerCase().indexOf('slr') === 0 ||
              parts[2].toLowerCase().indexOf('flood') === 0 ||
              parts[2].toLowerCase().indexOf('annual') === 0
          ))  {
        this.options.settings.statistic = parts[2];
        this._parseStatistic();
      }
    }
  },

  _updateMapWithState: function(selected) {
    var state = [selected ? '1' : '0', this.options.settings.emissions, this.options.settings.statistic];
    this._map.setProjectionsState(state.join('-'), true);
  },

  _onMapMoveEnd: function(){
    this.show();
  },

  _onWaterLevelChange: function(o, silent) {
    this.options.settings.waterlevel = this._map.getWaterLevel();
    if(!silent) this.show();
  },

  _processWaterUnit: function(unit) {
    return (unit === 'feet') ? 'ft' : 'm';
  },

  _onWaterUnitChange: function(o, silent) {
    this.options.settings.unit = this._processWaterUnit(this._map.getWaterUnit());
    if(!silent) this.show();
  },

  _onPopupClose: function() {
    this._selectedMarker = null;
  },

  _updateMeta: function(){
    var riskVal = this.riskDropdown.getValue();
    riskVal = riskVal.split(':'),
        text = "";
    if (this.options.settings.eventkey === 'slr') {
      text = '<span>Markers show when sea level rise reaches</span> <span class="notranslate">' + this.options.settings.waterlevel + '</span> <span>' + this.options.settings.unit + '</span>';
    } else {
      text = '<span>Markers show when sea level rise leads to a</span> <span class="notranslate">' + riskVal[1] + '% ' + riskVal[0] + '</span> <span>risk of flooding above</span> <span class="notranslate">' + this.options.settings.waterlevel + '</span> <span>' + this.options.settings.unit + '</span>';
    }

    this._contentContainer.select('#projections-ui-legend').html(text);
  },

  _parseStatistic: function() {

    if (this.options.settings.statistic === 'SLR') {
      this.options.settings.eventkey = 'slr';
    } else {
      this.options.settings.eventkey = 'flood';

      if (this.options.settings.statistic.indexOf('Flood') === 0) {
        this.options.settings.riskkey = 'accrued:' + this.options.settings.statistic.replace(/[^0-9\.]+/g, '');
      } else if (this.options.settings.statistic.indexOf('Annual') === 0) {
        this.options.settings.riskkey = 'annual:' + this.options.settings.statistic.replace(/[^0-9\.]+/g, '');
      }
    }

  },

  _toggleRiskDropdown: function() {
    var display = (this.options.settings.eventkey === 'slr') ? false : true;
    this._contentContainer.select('#projection-risk').classed('available', display);
  },

  _formatStatistic: function() {
    var riskVal = this.riskDropdown.getValue();
    var evtVal = this.eventDropdown.getValue();

    this.options.settings.riskkey = riskVal;
    this.options.settings.eventkey = evtVal;

    if (evtVal === 'slr') {
      this.options.settings.statistic = 'SLR';
    } else {
      riskVal = riskVal.split(':');

      if (riskVal[0] === 'accrued') {
        this.options.settings.statistic = "Flood" + riskVal[1] + "pct";
      } else {
        this.options.settings.statistic = "Annual" + riskVal[1] + "pct";
      }
    }

    this._toggleRiskDropdown();
  },

  setDropdowns: function() {
    var scenarioDropdown = this.scenarioDropdown = new stamen.DropDown($('#projections-dd-scenario'));
    var eventDropdown = this.eventDropdown = new stamen.DropDown($('#projections-dd-event'));
    var riskDropdown = this.riskDropdown = new stamen.DropDown($('#projections-dd-risk'));

    scenarioDropdown.setIndexByValue(this.options.settings.emissions);
    eventDropdown.setIndexByValue(this.options.settings.eventkey);
    riskDropdown.setIndexByValue(this.options.settings.riskkey);
    this._toggleRiskDropdown();
    this.setMarkerBackgroundKlass();

    var that = this;
    riskDropdown.on(function(idx, val){
      that._formatStatistic();
      that._updateMapWithState(that._selected);
      that.show();
    });

    eventDropdown.on(function(idx, val){
      that._formatStatistic();
      that._updateMapWithState(that._selected);
      that.show();
    });

    scenarioDropdown.on(function(idx, val){
      that.markerBackgroundKlass = scenarioDropdown.opts[idx].className;
      that.setMarkerBackgroundKlass();
      that.options.settings.emissions = val;

      that._updateMapWithState(that._selected);
      that.show();
    });

    Transifex.live.onTranslatePage(function(lang) {
      if (lang === "bn") {
        window.riskDropdown = riskDropdown;
        window.eventDropdown = eventDropdown;
        window.scenarioDropdown = scenarioDropdown;
        riskDropdown.dd.css({width: "auto", "padding-right": "5px"});
        riskDropdown.dd.find("ul.dropdown").css({width: "auto"});
        eventDropdown.dd.css({width: "auto", "padding-right": "5px"});
        eventDropdown.dd.find("ul.dropdown").css({width: "auto"});
        scenarioDropdown.dd.css({width: "auto", "padding-right": "5px"});
        scenarioDropdown.dd.find("ul.dropdown").css({width: "auto"});
      } else {
        riskDropdown.autosize();
        eventDropdown.autosize();
        scenarioDropdown.autosize();
      }
    });
  },

  setMarkerBackgroundKlass: function(idx) {
    idx = (idx === undefined) ? this.scenarioDropdown.getIndex() : idx;
    this.markerBackgroundKlass = this.scenarioDropdown.opts[idx].className;
  },

  createMarkers: function() {
    for (var gauge in this.gauges) {
      var props = this.gauges[gauge];
      var latlng = [props.Latitude, props.Longitude];
      var m = L.marker(latlng,{icon: new Surging.TideGauges.Icon});
      m.gaugeID = gauge;

      this.markers.push(m);
    }
  },

  handleGaugeClick: function(e) {

    if (e.originalEvent) {
      e.originalEvent.stopPropagation();
      e.originalEvent.preventDefault();
    }

    if (e.target && e.target.gaugeID) {
      var latlng = e.target.getLatLng();

      this._selectedMarker = e.target;

      if (!this._selected) this.toggleSelected();

      if (this.popup) {
        this.popup
            .setLatLng(latlng)
            .setContent(this.makePopupContent(e.target))
            .addTo(this._map);
      }
    }
  },

  translate: function(name) {
    var translation;
    if (Transifex.live.getSelectedLanguageCode() === "bn") {
      if (name === "Hiron Point") {
        return "হিরণ পয়েন্ট"
      } else if (name === "Charchanga") {
        return "চর ছাঙ্গা"
      } else if (name === "Cox'S Bazaar") {
        return "কক্সবাজার";
      } else if (name === "Khepupara") {
        return "খেপুপাড়া";
      } else {
        return name;
      }
    } else {
      return name;
    }
  },

  makePopupContent: function(marker) {
    var id = marker.gaugeID;
    var gauge = this.gauges[id];

    var content = ['<div>With '];

    // add emissions
    content.push('<span>' + this.lookups[this.options.settings.emissions] + '</span>, ');

    content.push('the median projection for when sea level rise ');

    // add event & risk copy
    var riskVal = this.riskDropdown.getValue();
    riskVal = riskVal.split(':');
    var eventVal = this.eventDropdown.getValue();
    var scenarioNumber = this.scenarioDropdown.getValue().replace('RCP','');

    if (eventVal !== 'slr') {
      content.push('leads to a <span class="notranslate">' + riskVal[1] + '%</span> ' + riskVal[0] + ' risk of flooding above ');
    } else {
      content.push('reaches ');
    }

    // add water level & unit
    content.push('<span class="notranslate">' + this.options.settings.waterlevel + '</span> ' + this.options.settings.unit + ' at ');

    // add gauge name
    content.push('<span class="notranslate">' + this.translate(gauge['ShortName']) + '</span> ');

    // Check to see if we have no year
    if (marker.observationsLabel === this.options.errors.icon) {
      content.push(this.options.errors.callout);
      content.push('</div>');
      return content.join('');
    }

    // add year
    content.push('is <span class="notranslate">' + marker.observationsLabel + '</span>');

    // apply likely range
    var range = marker.observations.filter(function(d){
      return d.percentile != 50;
    }).map(function(d){
      return d.year;
    });

    range = _.uniq(range).sort()
    if (range.length === 1 && range[0] == marker.observationsLabel) {
      content.push('.')
    } else {
      content.push(' (very likely range, <span class="notranslate">' + range.join(' - ') + '</span>).')
    }

    // close description
    content.push('</div>');

    // add links (if available)
    content.push('<div class="links">');
    if ('URL_download' in gauge && gauge['URL_download'].length) {
      var sensitivity = 50;
      var wl = this.options.settings.waterlevel
      if (this.options.settings.unit === 'm' && this._map._waterLevelSlider) {
        wl = this._map._waterLevelSlider.options.metersToFeetLookup[wl];
      }

      var dlURL = "http://riskfinder.climatecentral.org/api/forecast/tidegauge/" + id + "/BK?type=forecast-xls&slrdb=true";
      content.push(
          '<button data-gaugename="' + gauge['ShortName'] + '" data-gaugeid="' + id + '" ' + 'data-download-url="' + dlURL + '" ' + 'data-navtarget="getmoredata" data-paneltype="modal" data-gaq="Click:Get More Data:' + id + '"' +
          'onclick="panelController.gather(); ' +
          'panelController.openByName(\'getmoredata\'); ' +
          '$(\'#getmoredata_form > p\').html(\'<span>To download sea level rise projections through 2200 at </span><span class=notranslate>' + this.translate(gauge['ShortName']) + '</span><span>, please complete this form.</span>\');">' +
          '<span class="icon download"></span>Get more data</button>'
      );
    }
    var detailParts = gauge['URL_details'].split('XX');
    if ('URL_details' in gauge && gauge['URL_details'].length && detailParts.length === 3) {
      detailParts[0] += wl;
      detailParts[1] += scenarioNumber;
      content.push('<a href="' + detailParts.join('') + '" target="_blank"><span class="icon external-link"></span>See full tool</a>');
    }

    // done
    content.push('</div>');
    return content.join('');
  },

  findNearest: function(latlng) {
    if (!this.markers.length) return;

    latlng = latlng || this._map.getCenter();

    var distances = [];
    this.markers.forEach(function(m,i){
      var d = latlng.distanceTo(m.getLatLng());
      distances.push({
        idx: i,
        d: d
      });
    });

    distances.sort(function(a,b){
      return d3.ascending(a.d,b.d);
    });

    var closest = this.markers[distances[0].idx].getLatLng();
    distances.length = 0;
    distances = null;

    var bds = this._map.getBounds();
    bds.extend(closest);


    var that = this;
    var padding = 50;

    // we need to do this on next layout so we can get
    // height of the projections panel
    setTimeout(function(){
      var navHeight = $('.nav').height();
      var panelHeight = $('.surging-control-container').height();

      that._map.fitBounds(bds, {
        paddingTopLeft: [0, navHeight],
        paddingBottomRight: [0, panelHeight + padding]
      });
    }, 0);


  },

  show: function() {
    var that = this;
    that._updateMeta();

    var refreshGaugeLabels = function (m, gauge) {
      that._inView++;

      if (!that._map.hasLayer(m)) {
        m.addTo(that._map);
        m.on('touchstart click', that.handleGaugeClick, that);
      }

      var settings = that.options.settings;
      var obs = gauge.observations.filter(function(o) {
        return o.emissions.toLowerCase() === settings.emissions.toLowerCase() &&
            o.unit === settings.unit &&
            o.statistic === settings.statistic &&
            +o.waterlevel === settings.waterlevel;
      });

      var filtered = obs.filter(function(d) {
        return +d.percentile === 50;
      });

      m.observations = obs;

      var label;
      if (filtered.length) {
        label = (filtered[0].year) ? filtered[0].year : that.options.errors.icon;
      } else {
        label = that.options.errors.icon;
      }

      m.observationsLabel = label;

      m.options.icon.setInnerText(label);
      m.options.icon.setTipColorKlass(that.markerBackgroundKlass);
      if (label === that.options.errors.icon) {
        m.options.icon.setTipErrorKlass();
      }
    }

    var bds = this._map.getBounds();

    this._inView = 0;
    this.markers.forEach(function(m){
      if (bds.contains(m.getLatLng()) ) {
        var gauge = that.gauges[m.gaugeID];
        if ('observations' in gauge) {
          refreshGaugeLabels(m, gauge);
        } else {
          d3.tsv("/data/observations_slrdb/" + gauge['Station'] + "_observations.tsv", function (err, data) {
            gauge.observations = data;
            refreshGaugeLabels(m, gauge);
          });
        }
      } else {
        m.off('touchstart click', that.handleGaugeClick);
        that._map.removeLayer(m);
      }
    });

    if (this._selectedMarker && this.popup._map) {
      this.popup.setContent(this.makePopupContent(this._selectedMarker));
    }
  }



});

Surging.TideGauges.Popup = L.Popup.extend({
  _updatePosition: function () {
    if (!this._map) { return; }

    var pos = this._map.latLngToLayerPoint(this._latlng),
        animated = this._animated,
        offset = L.point(this.options.offset);


    if (animated) {
      L.DomUtil.setPosition(this._container, pos);
    }

    var height = this._contentNode.offsetHeight;

    this._containerBottom = -(height/2) - offset.y - (animated ? 0 : pos.y);

    //this._containerBottom = -offset.y - (animated ? 0 : pos.y);
    this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x + (animated ? 0 : pos.x);

    // bottom position the popup in case the height of the popup changes (images loading etc)
    this._container.style.bottom = this._containerBottom + 'px';
    this._container.style.left = this._containerLeft + 'px';
  }
});

Surging.TideGauges.Icon = L.Icon.extend({

  options: {
    iconSize: [], // also can be set through CSS
    className: 'tidegauge-marker',
    html: false
  },

  createIcon: function (oldIcon) {
    var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
        options = this.options;

    var tip = this.tip = L.DomUtil.create('div', 'tip');
    div.appendChild(tip);

    var tipText = this.tipText = L.DomUtil.create('span', 'label');
    var questionMark = L.DomUtil.create('span', 'icon dark question-mark');
    tip.appendChild(tipText);
    tip.appendChild(questionMark);

    this._setIconStyles(div, 'icon');

    return div;
  },

  setInnerText: function(txt) {
    if (!this.tipText) return;
    var prop = ('innerText' in this.tipText)? 'innerText' : 'textContent';
    this.tipText[prop] = txt
  },

  setTipColorKlass: function(klass) {
    this.tip.className = 'tip ' + klass;
  },

  setTipErrorKlass: function() {
    this.tip.className += ' error';
  },

  createShadow: function () {
    return null;
  }
});

Surging.Control.WaterLevelSlider = Surging.Control.extend({
  includes: L.Evented,
  touched: false,

  options: {
    label: "<h3>water level</h3><p>in feet</p>",
    position: "bottomleft",
    height: 334,
    minLevel: 1,
    maxLevel: 10,
    rangesMinMax: {
      feet: [1,10],
      meters: [1,30]
    },
    ranges: {
      feet: null, // takes an array: [1,2,3,4,5,6,7,8,9,10,20]; if null, creates a range from minLevel and maxLevel.
      meters: [0.5,1,1.5,2,2.5,3,5,10,20,30]
    },
    visible: false,
    noEffect: false,
    oneLevelHeight: null,
    minOneLevel: 28,
    maxOneLevel: 42,
    autoFit: true,
    smallScreenBreakpoint: 940,
    feetToMetersLookup: {
      "0": 0,
      "1": 0.5,
      "2": 0.5,
      "3": 1,
      "4": 1,
      "5": 1.5,
      "6": 2,
      "7": 2,
      "8": 2.5,
      "9": 2.5,
      "10": 3
    },
    metersToFeetLookup: {
      "0": 0,
      "0.5": 2,
      "1": 3,
      "1.5": 5,
      "2": 7,
      "2.5": 8,
      "3": 10,
      "5": 10,
      "6": 10,
      "10": 10,
      "20": 10,
      "30": 10
    },
    aboutTarget: 'water-level-def'
  },

  _levels: {
    feet: null,
    meters: null
  },
  _hiddenWaterLevel: null,
  _levelRange: null,
  _unit: null,

  setLevel: function(level, force) {
    if (level === this._levels[this._unit] && !force) return;

    this._levels[this._unit] = level;
    this._onSliderChange();
    this.setLevelPositions(level);
  },

  switchUnit: function(unit) {
    if (unit === this._unit) return;

    var level;
    if (this._unit === 'feet') {
      level = this.options.feetToMetersLookup[this._levels[this._unit]];
      if (this._hiddenWaterLevel) {
        this._hiddenWaterLevel = this.options.feetToMetersLookup[this._hiddenWaterLevel];
      }
    } else {
      level = this.options.metersToFeetLookup[this._levels[this._unit]];
      if (this._hiddenWaterLevel) {
        this._hiddenWaterLevel = this.options.metersToFeetLookup[this._hiddenWaterLevel];
      }
    }
    var toggleBtn = d3.select(".flooding-toggle");
    if (!toggleBtn.classed("showing")) {
      toggleBtn.html("Show <var>" + this._hiddenWaterLevel + "</var> " + unit);
    }

    this._unit = unit;
    this.setLevelRange();
    this.setWaterLevelScale();
    this.toggleUnitButtons(unit);
    this.makeLevelNumbers();
    this._updateBreakLines();
    this._map.options.composer.unit(unit);
    /*
     var level = this._levels[this._unit];
     if (level === null) {
     var idx = Math.floor(this._levelRange.length/2);
     level = this._levelRange[idx];
     }*/
    this.setUnitClass();
    this.setLevel(level, true);
  },

  calcOneLevel: function(height) {
    if (this.options.oneLevelHeight) return this.options.oneLevelHeight;

    // calculate
    height = height || this.options.height;
    var raw = height / this._levelRange.length;

    var rounded = raw - (raw % 2);

    // restrict
    if (this.options.minOneLevel) rounded = Math.max(rounded, this.options.minOneLevel);
    if (this.options.maxOneLevel) rounded = Math.min(rounded, this.options.maxOneLevel);

    // return
    return rounded;
  },

  getLevelIndex: function(level) {
    return this._levelRange.indexOf(level);
  },

  getLevel: function() {
    return this._levels[this._unit];
  },

  isVisible: function() {
    if (!this.touched) {
      if (window.innerWidth < this.options.smallScreenBreakpoint) return false;
    }
    return this.options.visible;
  },

  stepWaterLevel: function(dir) {
    var idx = this.getLevelIndex(this.getLevel());
    idx += dir;

    if (idx >= 0 && idx < this._levelRange.length) {
      this.setLevel(this._levelRange[idx]);
    }
  },

  setWaterLevelScale: function() {
    this.waterLevelScale = d3.scale.linear()
        .domain([0, this._levelRange[this._levelRange.length-1] ])
        .range([100, 0]);
  },

  setLevelRange: function() {
    var min = this.options.rangesMinMax[this._unit][0],
        max = this.options.rangesMinMax[this._unit][1];

    this._levelRange  = (!this.options.ranges[this._unit]) ? d3.range(min, max + 1) : this.options.ranges[this._unit];
  },

  getToggleIconClass: function() {
    return this.options.visible ? 'icon toggle-down' : 'icon toggle-up'
  },

  toggleUnitButtons: function(unit) {
    this.unitButtons.selectAll('button')
        .classed('selected', false)
        .filter(function(){
          return this.getAttribute('data-unit') === unit;
        })
        .classed('selected', true);
  },

  setUnitClass: function() {
    this._slider.classed('unit-feet', false).classed('unit-meters', false).classed('unit-'+ this._unit, true);
  },

  toggleSliderDisplay: function() {
    if (!this.touched) {
      this.touched = true;
      this._slider.classed('untouched', false);
      if (window.innerWidth > this.options.smallScreenBreakpoint) {
        this.options.visible = !this._slider.classed('open');
      }
    } else {
      this.options.visible = !this._slider.classed('open');
    }

    this._slider.classed('open', this.options.visible);
    this._slider.select('.fill-circle').classed('closed', !this.options.visible);
    this._toggleIcon.attr('class', this.getToggleIconClass());
    this.setLevelPositions(this.getLevel());
    if (this.options.noEffect) {
      this.toggleFlooding();
    }
    this._slider.select('.fill-text')
        .style('line-height', this._slider.select('.fill-circle').style("width"));
  },

  _onSliderChange: function(e) {
    if (this._changing) return false;
    this._map.options.composer.level(this._levels[this._unit]);
    this._map.setWaterUnit(this._unit);
    this._map.setWaterLevel(this._levels[this._unit], true);
  },

  _onWaterLevelChange: function(e) {
    this._changing = true;
    this.setLevel(this._map.getWaterLevel());
    if (typeof ga !== 'undefined') {
      ga('send', 'event', Surging.campaign, 'Water level change: ' +  this._map.getWaterLevel());
      ga(Surging.campaign + '.send', 'event', 'water-level', 'configure', this._map.getWaterLevel());
    }
    this._changing = false;
  },

  autoSize: function() {
    if (!this.options.autoFit) return;
    if (!this._slider) return;

    var rect = this._slider.node().getBoundingClientRect();

    var winHeight = this.windowHeight = window.innerHeight,
        protectedTop = 140,
        toggleBtnHeight = 51,
        padding = 10;

    var height = this.height = rect.bottom - protectedTop - toggleBtnHeight;
    var oneLevel = this._currentOneLevelHeight = this.calcOneLevel(height);
    var circleRadius = oneLevel - padding;
    var circleDiameter = circleRadius * 2;

    this._bar.classed('small', (oneLevel === this.options.minOneLevel) );

    this._slider.selectAll('.level')
        .style('line-height', oneLevel + 'px');

    var fillCircle = this._slider.select('.fill-circle');

    fillCircle
        .style('width', circleDiameter + 'px')
        .style('height', circleDiameter + 'px')
        .style('margin-top', -circleRadius + 'px')
        .style('margin-left', -circleRadius + 'px')
        .style('font-size', circleDiameter + 'px');

    if (this._slider.classed("untouched")) {
      this._slider.select('.fill-text')
          .style('line-height', '64px');
    } else {
      this._slider.select('.fill-text')
          .style('line-height', circleDiameter + 'px');
    }

    this._updateBreakLines();

    this.setLevelPositions(this.getLevel());
  },

  _updateBreakLines: function() {
    if (!this._currentOneLevelHeight) return;
    var oneLevel = this._currentOneLevelHeight;

    var h3 = ((this.getLevelIndex(3)+1) * oneLevel - oneLevel / 2) + 8;
    var h5 = ((this.getLevelIndex(5)+1) * oneLevel - oneLevel / 2) + 8;

    this._slider.select('.breakline.break-three')
        .style('bottom', h3 + "px");
    this._slider.select('.breakline.break-five')
        .style('bottom', h5 + "px");
  },

  isDoubleDigit: function(n) {
    return n >= 10;
  },

  isDecimal: function(n) {
    return Math.floor(n) !== n;
  },

  setLevelPositions: function(level) {
    var self = this;
    var levelIndex = this.getLevelIndex(level);
    if (levelIndex === -1) return;

    var oneLevel = this.calcOneLevel(this.height);

    var steppedHeight = (levelIndex + 1) * oneLevel - oneLevel / 2;

    this._slider.select(".fill")
        .style("height", steppedHeight + "px");

    var fillCirclePosition = (this.options.visible) ? steppedHeight - this.fillCircle.node().offsetHeight/2 : 0;

    this.fillCircle
        .style('bottom', fillCirclePosition + "px");

    this.fillCircleText
        .classed("doubledigit", this.isDoubleDigit(level))
        .classed("decimal", this.isDecimal(level))
        .text(level)
        .style("font-size", null);

    this._slider
        .selectAll(".level")
        .classed("flooded", function(d) {
          return d < level;
        })
        .classed("popped", function(d) {
          return d === level;
        });

    this._slider.select('.water-level')
        .style('top', this.waterLevelScale(level) + '%');
  },

  toggleFlooding: function() {
    var btn = d3.select(".flooding-toggle");
    var self = this;
    if (btn.classed("showing")) {
      if (parseInt(this._bar.style("height")) > 0) {
        self.toggleSliderDisplay();
      }
      btn.html('Show <var>' + self.getLevel() + "</var> " + self._unit);
      btn.classed("showing", false);
      self.options.noEffect = true;
      self._hiddenWaterLevel = self.getLevel();
      self.setLevel(0);
      setTimeout(function() {
        self.fillCircleText
            .classed("doubledigit", false)
            .classed("decimal", false)
            .text("Current coast")
            .style("font-size", "13px")
            .style("line-height", "15px")
            .style("margin-top", "17px");
        d3.select(".water-level")
            .style("top", "100%");
      }, 1);
    } else {
      self.fillCircleText
        .style("font-size", "")
        .style("line-height", "")
        .style("margin-top", "");
      btn.text("Show current coast");
      btn.classed("showing", true);
      self.options.noEffect = false;
      self.setLevel(self._hiddenWaterLevel);
    }
  },

  onAdd: function(map) {
    this._map = map;
    this._map.on("waterlevel", this._onWaterLevelChange, this);

    this._unit = this._map.getWaterUnit();
    this._map.options.composer.unit(this._unit);
    this.setLevelRange();
    this.setWaterLevelScale();

    var self = this,
        opts = this.options,
        container = L.DomUtil.create("div", "water-level-control surging-control"),
        slider = this._slider = d3.select(container),
        ns = ".h2o",
        mousedown = (L.Browser.touch ? "touchstart" : "mousedown") + ns,
        mousemove = (L.Browser.touch ? "touchmove" : "mousemove") + ns,
        mouseup = (L.Browser.touch ? "touchend" : "mouseup") + ns;

    //var viz = (window.innerWidth <= this.options.smallScreenBreakpoint) ? false : this.options.visible;
    this._slider.classed('open', this.options.visible);
    this._slider.classed('untouched', true);
    this.setUnitClass();


    // water slider toggle button
    var toggleDisplay = slider.append('div')
        .attr('class', 'slider-toggle')
        .append('button');

    toggleDisplay.append('span')
        .text('Water level');

    toggleDisplay.append('span')
        .attr('class', 'icon question-mark')
        .attr('data-abouttarget', this.options.aboutTarget);

    var toggleIcon = this._toggleIcon = toggleDisplay.append('span')
        .attr('class', this.getToggleIconClass());

    toggleDisplay.on('click', function(){
      L.DomEvent.stop(d3.event);
      self.toggleSliderDisplay();
    });

    // water slider bar
    var bar = this._bar = slider.append("div")
        .attr("class", "bar")
        .on(mousedown + ns, startDrag);

    var timeout;
    function startDrag() {
      if (!self.options.visible) {
        L.DomEvent.stop(d3.event);
        return false;
      }
      var body = d3.select("body")
          .classed("water-dragging", true);
      body.on(mousemove, move);
      d3.select(window).on(mouseup, stopDrag);
      d3.event.preventDefault();
    }

    function move() {
      var node = bar.node(),
          pos = L.Browser.touch
              ? d3.touches(node)[0]
              : d3.mouse(node),
          y = pos[1],
          scale = d3.scale.quantize()
              .domain([node.offsetHeight, 0])
              .range(self._levelRange),
          level = scale(y);

      clearTimeout(timeout);
      timeout = setTimeout(function() {

        self.setLevel(level);
      }, 10);

      d3.event.stopPropagation();
    }

    function stopDrag() {
      var body = d3.select("body")
          .classed("water-dragging", false);
      //console.log("[mouseup]");
      body.on(mousemove, null);
      //body.on("mouseup.h2o", null);
      d3.select(window).on(mouseup, null);
    }

    bar.append('div')
        .attr('class', 'breakline break-five');

    bar.append('div')
        .attr('class', 'breakline break-three');

    // water slider fill
    var fill = bar.append("div")
        .classed("fill", true);

    // water slide level indicator
    this.fillCircle = bar.append("div")
        .classed("fill-circle", true);

    this.fillCircle.append('div')
        .attr('class', 'water-level');

    this.fillCircleText = this.fillCircle.append('div')
        .attr('class', 'fill-text');

    // water level numbers
    this.makeLevelNumbers();

    // make unit selector
    var unitSelector = slider.append("div")
        .classed("unit-selector", true);

    var unitButtons = this.unitButtons = unitSelector.append('div')
        .attr('class','unit-buttons');

    unitButtons.append('button')
        .attr('data-unit', 'feet')
        .text('ft');

    unitButtons.append('button')
        .attr('data-unit', 'meters')
        .text('m');

    unitButtons.selectAll('button')
        .on('click', function(){
          L.DomEvent.stop(d3.event);
          var unit = d3.select(this).attr('data-unit');
          self.switchUnit(unit);
        });

    this._floodingToggle = slider.append("button")
        .attr("class", "flooding-toggle showing")
        .text("Show current coast")
        .on("click", this.toggleFlooding.bind(self));

    Surging.Util.preventMouseEvents(container);

    // initialize things
    this.toggleUnitButtons(this._unit);

    if (this.options.level) {
      this.setLevel(this.options.level);
    } else {
      this.setLevel(this._map.getWaterLevel());
    }

    this._map._waterLevelSlider = this;

    this.windowHeight = window.innerHeight;

    var resizeHandler = Surging.Util.debounce(this._onWindowResize, 250).bind(this);
    d3.select(window).on('resize.wls', resizeHandler);

    return container;
  },

  _onWindowResize: function() {
    if (window.innerHeight === this.windowHeight) return;
    this.autoSize();
  },

  makeLevelNumbers: function() {
    // FIXME Figure out how to get the slider height dynamically
    // (if you want to use bar.property("offsetHeight"), you'll need to wait
    // until the container is added to the DOM -SA)
    var oneLevel = this.calcOneLevel(this.height),
        bar = this._slider.select('.bar'),
        self = this;

    // remove old numbers;
    var numbers = bar.selectAll("p");
    numbers.on('mousedown', null);
    numbers.on('touchstart', null);
    numbers.remove();

    // create new ones
    numbers = bar.selectAll("p")
        .data(this._levelRange.slice().reverse());

    numbers.enter()
        .append("p")
        .text(function(d) { return d; })
        .attr("class", function(d) {
          return ["level" + d, "level"].join(" ");
        })
        .style("line-height", oneLevel + "px")
        .classed("doubledigit", function(d) { return self.isDoubleDigit(d); })
        .classed("decimal", function(d) { return self.isDecimal(d); });

    numbers.append("div")
        .attr("class", "level-tick");

    numbers.on("mousedown", function(d) {
      self.setLevel(d);
    });

    numbers.on("touchstart", function(d) {
      self.setLevel(d);
    });

    return numbers;
  },

  onRemove: function(map) {
    d3.select(window).on('resize.wls', null);
    this.unitButtons.selectAll('button').off('click', null);
    this._map._waterLevelSlider = null;
    this._slider.onchange = null;
    this._slider.remove();
    this._slider = this._label = this._toggleIcon = null;
    this._map.off("waterlevel", this._onWaterLevelChange);
    this._map.options.composer = null;
    this._map = null;
  }
});

Surging.Control.ComposerStatus = L.Control.extend({
  options: {
    size: 200,
    vertical: true,
    loadingLabel: "Loading tiles: <tt>%s</tt>",
    loadedLabel: "Loaded tiles: %s",
    checkRate: 100,
    position: "topleft"
  },

  onAdd: function(map) {
    var div = L.DomUtil.create("div", "surging-control composer-status");
    this._fill = d3.select(div)
        .classed("vertical", this.options.vertical)
        .append("div")
        .attr("class", "fill");
    this.startUpdating();
    this._map = map;
    return div;
  },

  onRemove: function(map) {
    this.stopUpdating();
    this._map = null;
    return L.Control.prototype.onRemove.call(this, map);
  },

  update: function() {
    var total = 0,
        loaded = 0,
        textFormat = this.options.loadingLabel,
        tiles = d3.select(this._map._container)
            .selectAll(".leaflet-tile")
            .each(function() {
              if (this.src === L.Util.emptyImageUrl) return;
              total++;
              if (this.loaded || this.classList.contains("leaflet-tile-loaded")) loaded++;
            });

    if (loaded) {
      if (this.options.loadedLabel) textFormat = this.options.loadedLabel;
      this._container.classList.add("loaded");
      this._container.classList.remove("loading");
    } else {
      this._container.classList.add("loading");
      this._container.classList.remove("loaded");
    }

    var percent = loaded + " / " + total,
        fillSize = 100 * loaded / total,
        title = textFormat.replace(/%s/g, percent);
    this._fill.style(this.options.vertical ? "height" : "width", Math.round(fillSize) + "%");
    this._container.setAttribute("title", title);
  },

  startUpdating: function() {
    this._checkInterval = setInterval(L.Util.bind(this.update, this), this.options.checkRate);
  },

  stopUpdating: function() {
    clearInterval(this._checkInterval);
  }
});


Surging.Embed = {};

Surging.Embed.Authoring = function() {
  var contentTitle = "";
  var contentUrl = "";
  var contentName = "";
  // Something with properties of window.location
  var loc;
  var contentTitle, contentUrl, contentName;
  var my = {};

  my.iframeUrl = function() {
    content_fragment = "";

    if (contentTitle) {
      if (loc.hash.indexOf("?") >= 0) {
        content_fragment += "&";
      } else {
        content_fragment += "?";
      }
      content_fragment += "contentTitle=" + encodeURIComponent(contentTitle);

      if (contentUrl) {
        content_fragment += "&contentUrl=" + encodeURIComponent(contentUrl);
      }
    }
    tracking_fragment = "?";
    tracking_fragment += "utm_source=" + encodeURIComponent(contentName) + "&utm_medium=embed&utm_campaign=" + Surging.Embed.campaign;

    var port_str = loc.port ? (":" + loc.port) : "";
    return loc.protocol + "//" + loc.hostname + port_str + basepath() + Surging.Embed.widgetTemplate + tracking_fragment + loc.hash + content_fragment;
  }

  my.snippet = function() {
    var compiled = _.template("&lt;iframe style=\"border:0px;scrolling:no;width:100%;height:530px\" src=\"<%=src%>\"&gt;&lt;/iframe&gt;")
    if(contentName == "NONE" || contentName == "")
    {
      return "Please enter your name/organization above to see this code.";
    }

    return compiled({src:my.iframeUrl()});
  };

  my.loc = function(value) {
    if (!arguments.length) return loc;
    loc = value;
    return my;
  }

  function basepath() {
    return loc.pathname.substring(0,loc.pathname.lastIndexOf("/")+1);
  }

  my.contentTitle = function(value) {
    if(!arguments.length) return contentTitle;
    contentTitle = value;
    return my;
  }

  my.contentUrl = function(value) {
    if(!arguments.length) return contentUrl;
    contentUrl = value;
    return my;
  }

  my.contentName = function(value) {
    if(!arguments.length) return contentName;
    contentName = value;
    return my;
  }

  my.shouldShowPreviewFooter = function() {
    if(contentTitle == "" || !contentTitle) return false;
    return true;
  }

  return my;
};

// handles managing the widget's footer, etc.
Surging.Embed.WidgetManager = function(hash) {
  var result = Surging.Util.QueryString.parseHash(hash);
  var contentTitle = result.contentTitle;
  var contentUrl = result.contentUrl;
  var contentName = result.contentName;
  var show = result.show;

  var my = {};

  function isData() {
    return show && show != "satellite";
  }

  my.footerHeight = function() {
    if(contentTitle && isData()) {
      return "60px";
    } else if(contentTitle || isData()) {
      return "50px";
    } else {
      return "0px";
    }
  }

  my.footerDisplay = function() {
    if(contentTitle || isData()) {
      return "inline";
    } else {
      return "none";
    }
  }

  my.contentTitle = function(value) {
    if(!arguments.length) return contentTitle;
    contentTitle = value;
    return my;
  }

  my.contentUrl = function(value) {
    if(!arguments.length) return contentUrl;
    contentUrl = value;
    return my;
  }

  my.contentName = function(value) {
    if(!arguments.length) return contentName;
    contentName = value;
    return my;
  }

  my.projections = function() {
    var proj = 0;
    if (result.projections && result.projections.split) {
      var parts = result.projections.split('-');
      if (parts.length === 3 && parts[0] === "1") proj = 1;
    }
    return proj;
  }

  my.pois = function() {
    return result.pois && result.pois === 'show';
  }
  my.show = function() {
    return show;
  }


  var keys = {
    'popd':"population density",
    'sovi':"social vulnerability",
    'income':"income level",
    'property':"property value",
    "ethnicity": "one dot per person, color-coded by ethnicity,"
  }

  my.lines = function() {
    var retval = [];
    if(contentTitle) retval.push({'c':'title','t':contentTitle});
    if(keys[show]) retval.push({'c':'caption',"t":"This map is displaying " + keys[show] + " in areas below the water level."});
    return retval;
  }

  var redyellow = [{'s':'HIGH','background_color':'#d53e4f','color':'white'},
    {'s':'LOW','background_color':'#fee08b','color':'black'}];
  var yellowred = [{'s':'LOW','background_color':'#d53e4f','color':'white'},
    {'s':'HIGH','background_color':'#fee08b','color':'black'}];
  var ethnicity = [
    {'s':'WHITE','background_color':'#f8ec7c','color':'black'},
    {'s':'ASIAN','background_color':'#53eb85','color':'black'},
    {'s':'HISPANIC','background_color':'#00d3ff','color':'black'},
    {'s':'BLACK','background_color':'#ff00d3','color':'white'},
    {'s':'NATIVE AMERICAN','background_color':'#b000ff','color':'white'}
  ];

  my.scaleData = function() {
    if(show == 'income') {
      return yellowred;
    } else if (show == "ethnicity") {
      return ethnicity;
    } else {
      return redyellow;
    }
  }

  return my;
}

Surging.Embed.Show = function() {
  Surging.Embed.authoring.loc(window.location);
  d3.select("#iframegoeshere").append("iframe").attr("src",Surging.Embed.authoring.iframeUrl()).attr('tabindex','-1');
  d3.select("#copypastethis").html(Surging.Embed.authoring.snippet());
}

Surging.Embed.Hide = function() {
  d3.select("#iframegoeshere").selectAll("iframe").remove();
}

// Only to be called when my window.document is index.html
Surging.Embed.Index = function() {
  Surging.Embed.widgetTemplate = Surging.Embed.widgetTemplate || 'widget.html';
  Surging.Embed.campaign = Surging.Embed.campaign || 'SS2-Map';
  Surging.Embed.authoring = Surging.Embed.Authoring();

  var element;
  element = $("#embed-content-name")[0];
  element.onkeyup = function() {
    e = d3.select("#theembedpage iframe").node().contentWindow.Surging.Embed;
    var w = e.widgetManager;
    w.contentName(this.value);
    e.DrawWidget(w);
    Surging.Embed.authoring.contentName(this.value);
    d3.select("#copypastethis").html(Surging.Embed.authoring.snippet());
  };


  d3.select("#embed-content-title").on("keyup", function(d) {
    e = d3.select("#theembedpage iframe").node().contentWindow.Surging.Embed;
    var w = e.widgetManager;
    w.contentTitle(this.value);
    e.DrawWidget(w);
    Surging.Embed.authoring.contentTitle(this.value);
    d3.select("#copypastethis").html(Surging.Embed.authoring.snippet());
  });

  d3.select("#embed-content-url").on("keyup", function(d) {
    e = d3.select("#theembedpage iframe").node().contentWindow.Surging.Embed;
    var w = e.widgetManager;
    w.contentUrl(this.value);
    e.DrawWidget(w);
    Surging.Embed.authoring.contentUrl(this.value);
    d3.select("#copypastethis").html(Surging.Embed.authoring.snippet());
  });
};

// Only to be called when my window.document is widget.html
Surging.Embed.Widget = function(hash) {
  var w = Surging.Embed.WidgetManager(hash)
  Surging.Embed.widgetManager = w;
  Surging.Embed.DrawWidget(w);
}

Surging.Embed.RiskWidget = function(hash, map) {
  var w = Surging.Embed.WidgetManager(hash)
  Surging.Embed.widgetManager = w;
  Surging.Embed.DrawRiskWidget(w, map);
}

Surging.Embed.DrawWidget = function(w) {
  d3.select("#viewfullsizemap").attr("href","index.html" + window.location.hash);
  d3.select("#ft #title").text(w.contentTitle());
  d3.select("#contentLink").attr("href",w.contentUrl());
  d3.select("#embed-footer").style("display",w.footerDisplay());
  d3.select("#ft").style("height",w.footerHeight());
  d3.select("#ft").style("line-height",w.footerHeight());
  d3.select("#mapContainer").style("bottom",w.footerHeight());

  var sel = d3.select("#ft .centered-span").selectAll("div").data(w.lines(), function(d) { return d.c });
  sel.sort(function(d) { return d.c });
  sel.enter().append("div").attr("class", function(d) { return d.c });
  sel.text(function(d) { return d.t });
  sel.exit().remove();

  d3.select("#ft .caption").selectAll("span").data(w.scaleData()).enter().append("span")
      .style("background-color", function(d) { return d.background_color })
      .style("color", function(d) { return d.color })
      .text(function(d) { return d.s })
}

Surging.Embed.DrawRiskWidget = function(w, map) {
  d3.select("#viewfullsizemap").attr("href","index.html" + window.location.hash);

  // set legend
  var toggleContainer = new Surging.ToggleContainer();
  toggleContainer.addTo(map);

  // add a footer in there
  var footer = d3.select('.surging-control-container').append('div').attr('class', 'embed-footer');

  // logo next
  var logoLink = footer.append('a')
      .attr('class', 'climate-central-logo');

  logoLink
      .append('img')
      .attr('src', 'css/images/logo-climate-central-footer-white.png')
      .attr('alt', 'Climate Central')
      .attr('id','logo-footer');

  // if provided a content title
  // add it
  if (w.contentTitle()) {
    footer.append('a')
        .attr('class', 'footer-content')
        .attr('href', w.contentUrl())
        .text(w.contentTitle());
  }

  // set data layer key
  if (w.pois()) {
    toggleContainer.insertButton(new Surging.Control.LandmarksControl(Surging.DataLayers('landmarks')));
  } else if (w.projections()) {
    toggleContainer.insertButton(new Surging.TideGauges(Surging.DataLayers('projections')));
  } else {
    switch (w.show()) {
      case 'sovi':
        toggleContainer.insertButton(new Surging.Control.SoviToggle( Surging.DataLayers('sovi', null) ));
        break;
      case 'popd':
        toggleContainer.insertButton(new Surging.Control.popdToggle( Surging.DataLayers('population', null)));
        break;
      case 'ethnicity':
        toggleContainer.insertButton(new Surging.Control.ethnicityToggle( Surging.DataLayers('ethnicity', null)));
        break;
      case 'income':
        toggleContainer.insertButton(new Surging.Control.incomeToggle(Surging.DataLayers('income')));
        break;
      case 'property':
        toggleContainer.insertButton(new Surging.Control.propertyToggle(Surging.DataLayers('property', null)));
        break;
    }
  }

  // data layer add misc stuff
  if (toggleContainer.buttonsCount()) {
    d3.select('body').classed('has-data-layers', true);

    d3.select('.surging-control-container')
        .append('button')
        .attr('class', 'toggle-panel')
        .text('hide')
        .on('click', function() {
          d3.event.preventDefault();
          var container = d3.select('.surging-control-container');
          var show = container.classed('hide-panel');

          container.classed('hide-panel', !show);
          d3.select(this)
              .text(show ? 'hide':'show');

        });

    toggleContainer.fire('change');
  }

}

Surging.Util = {};

// http://stackoverflow.com/a/24035537
Surging.Util.hideKeyboard = function() {
  //this set timeout needed for case when hideKeyborad
  //is called inside of 'onfocus' event handler
  setTimeout(function() {

    //creating temp field
    var field = document.createElement('input');
    field.setAttribute('type', 'text');
    //hiding temp field from peoples eyes
    //-webkit-user-modify is nessesary for Android 4.x
    field.setAttribute('style', 'position:absolute; top: 0px; opacity: 0; -webkit-user-modify: read-write-plaintext-only; left:0px;');
    document.body.appendChild(field);

    //adding onfocus event handler for out temp field
    field.onfocus = function(){
      //this timeout of 200ms is nessasary for Android 2.3.x
      setTimeout(function() {

        field.setAttribute('style', 'display:none;');
        setTimeout(function() {
          document.body.removeChild(field);
          document.body.focus();
        }, 14);

      }, 200);
    };
    //focusing it
    field.focus();

  }, 50);
};

Surging.Util.setNavLink = function() {
  d3.selectAll('.nav h1 a')
      .attr('href', function(){
        return document.location.href.split('#')[0];
      });
}

// http://stackoverflow.com/a/11381730/989439
Surging.Util.mobilecheck = function() {
  var check = false;
  (function(a){if(/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};


// a useful method for preventing mouse and touch events from bubbling up
// to the map
Surging.Util.preventMouseEvents = function(element) {
  "mousedown click dblclick touchstart touchend".split(" ").forEach(function(e) {
    if (element instanceof Array) element = element[0];

    L.DomEvent.addListener(element, e, L.DomEvent.stopPropagation);
  });
};

Surging.Util.debounce = function(fn, delay) {
  var timeout;
  return function() {
    clearTimeout(timeout);
    var that = this, args = arguments;
    timeout = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
};

// query string parse & format
Surging.Util.QueryString = {
  parseHash: function(str) {
    var start = str.indexOf("?");
    if (start >= 0) return Surging.Util.QueryString.parse(str.substr(start));
    return {};
  },

  parse: function(str) {
    if (str.charAt(0) === "?") str = str.substr(1);
    if (str.length < 2) return {};
    var parts = str.split("&"),
        len = parts.length,
        query = {};
    for (var i = 0; i < len; i++) {
      var bits = parts[i].split("=", 2),
          key = bits[0],
          val = (bits.length > 1)
              ? decodeURIComponent(bits[1]).replace(/\+/g, " ")
              : true;
      switch (val) {
        case "true": val = true; break;
        case "false": val = false; break;
        default:
          var num = Number(val);
          if (!isNaN(num)) val = num;
          break;
      }
      query[key] = val;
    }

    return query;
  },
  format: function(obj, sortKeys) {
    var entries = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)
          && obj[key] !== null
          && typeof obj[key] !== "function"
          && typeof obj[key] !== "undefined") {
        entries.push({key: key, value: obj[key]});
      }
    }
    if (sortKeys) {
      keys.sort(function(a, b) {
        return a.key > b.key ? 1 : a.key < b.key ? -1 : 0;
      });
    }
    return "?" + entries.map(function(entry) {
          return [entry.key, encodeURIComponent(entry.value)].join("=");
        }).join("&");
  }
};

export default Surging;
